// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AdminLoginApiV1AuthAdminLoginPostData, AdminLoginApiV1AuthAdminLoginPostErrors, AdminLoginApiV1AuthAdminLoginPostResponses, AnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostData, AnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostErrors, AnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostResponses, AppleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGetData, AppleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGetResponses, AppleLoginApiV1AuthAppleLoginPostData, AppleLoginApiV1AuthAppleLoginPostErrors, AppleLoginApiV1AuthAppleLoginPostResponses, AppleServerNotificationsV2ApiV1PaymentsAppleNotificationsPostData, AppleServerNotificationsV2ApiV1PaymentsAppleNotificationsPostErrors, AppleServerNotificationsV2ApiV1PaymentsAppleNotificationsPostResponses, AppleVerifyPurchaseApiV1PaymentsAppleVerifyPostData, AppleVerifyPurchaseApiV1PaymentsAppleVerifyPostErrors, AppleVerifyPurchaseApiV1PaymentsAppleVerifyPostResponses, BlockUserEndpointApiV1AuthUserUserIdBlockPostData, BlockUserEndpointApiV1AuthUserUserIdBlockPostErrors, BlockUserEndpointApiV1AuthUserUserIdBlockPostResponses, CharacterLastMessageApiV1CharacterCharacterLastMessageGetData, CharacterLastMessageApiV1CharacterCharacterLastMessageGetErrors, CharacterLastMessageApiV1CharacterCharacterLastMessageGetResponses, CharacterSendMessageApiV1CharacterCharacterSendMessagePostData, CharacterSendMessageApiV1CharacterCharacterSendMessagePostErrors, CharacterSendMessageApiV1CharacterCharacterSendMessagePostResponses, CharacterStreamApiV1CharacterCharacterStreamPostData, CharacterStreamApiV1CharacterCharacterStreamPostErrors, CharacterStreamApiV1CharacterCharacterStreamPostResponses, CheckPhotoApiV1AuthCheckPhotoPostData, CheckPhotoApiV1AuthCheckPhotoPostErrors, CheckPhotoApiV1AuthCheckPhotoPostResponses, CheckPhotoQualityApiV1AuthCheckPhotoQualityPostData, CheckPhotoQualityApiV1AuthCheckPhotoQualityPostErrors, CheckPhotoQualityApiV1AuthCheckPhotoQualityPostResponses, CheckUserExistsApiV1AuthCheckUserPostData, CheckUserExistsApiV1AuthCheckUserPostErrors, CheckUserExistsApiV1AuthCheckUserPostResponses, CloudpaymentsCancelApiV1PaymentsCloudpaymentsCancelPostData, CloudpaymentsCancelApiV1PaymentsCloudpaymentsCancelPostResponses, CloudpaymentsCheckApiV1PaymentsCloudpaymentsCheckPostData, CloudpaymentsCheckApiV1PaymentsCloudpaymentsCheckPostResponses, CloudpaymentsFailApiV1PaymentsCloudpaymentsFailPostData, CloudpaymentsFailApiV1PaymentsCloudpaymentsFailPostResponses, CloudpaymentsPayApiV1PaymentsCloudpaymentsPayPostData, CloudpaymentsPayApiV1PaymentsCloudpaymentsPayPostResponses, CloudpaymentsRecurrentApiV1PaymentsCloudpaymentsRecurrentPostData, CloudpaymentsRecurrentApiV1PaymentsCloudpaymentsRecurrentPostResponses, CloudpaymentsRefundApiV1PaymentsCloudpaymentsRefundPostData, CloudpaymentsRefundApiV1PaymentsCloudpaymentsRefundPostResponses, CompleteEiTestApiV1AuthEiTestCompletePostData, CompleteEiTestApiV1AuthEiTestCompletePostErrors, CompleteEiTestApiV1AuthEiTestCompletePostResponses, CountOpenFriendRequestsApiV1AuthUserCountOpenFriendRequestsUserIdGetData, CountOpenFriendRequestsApiV1AuthUserCountOpenFriendRequestsUserIdGetErrors, CountOpenFriendRequestsApiV1AuthUserCountOpenFriendRequestsUserIdGetResponses, CreateAdminApiV1AuthAdminCreatePostData, CreateAdminApiV1AuthAdminCreatePostErrors, CreateAdminApiV1AuthAdminCreatePostResponses, CreateCardApiV1AuthUserUserIdCardsPostData, CreateCardApiV1AuthUserUserIdCardsPostErrors, CreateCardApiV1AuthUserUserIdCardsPostResponses, CreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostData, CreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostErrors, CreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostResponses, CreateThoughtApiV1UsersPostData, CreateThoughtApiV1UsersPostErrors, CreateThoughtApiV1UsersPostResponses, CreateThoughtByUserIdApiV1UsersUserIdThoughtsPostData, CreateThoughtByUserIdApiV1UsersUserIdThoughtsPostErrors, CreateThoughtByUserIdApiV1UsersUserIdThoughtsPostResponses, DebugAccentuationsValidationQuestionApiV1LuniDebugAccentuationsValidationQuestionUserIdGetData, DebugAccentuationsValidationQuestionApiV1LuniDebugAccentuationsValidationQuestionUserIdGetErrors, DebugAccentuationsValidationQuestionApiV1LuniDebugAccentuationsValidationQuestionUserIdGetResponses, DebugMessagesApiV1LuniDebugMessagesUserIdGetData, DebugMessagesApiV1LuniDebugMessagesUserIdGetErrors, DebugMessagesApiV1LuniDebugMessagesUserIdGetResponses, DebugProcessValidationReplyApiV1LuniDebugProcessValidationReplyPostData, DebugProcessValidationReplyApiV1LuniDebugProcessValidationReplyPostResponses, DeleteCardApiV1AuthUserUserIdCardsCardIdDeleteData, DeleteCardApiV1AuthUserUserIdCardsCardIdDeleteErrors, DeleteCardApiV1AuthUserUserIdCardsCardIdDeleteResponses, DeleteTelegramUserEndpointApiV1TelegramTelegramIdDeleteData, DeleteTelegramUserEndpointApiV1TelegramTelegramIdDeleteErrors, DeleteTelegramUserEndpointApiV1TelegramTelegramIdDeleteResponses, DeleteThoughtApiV1UsersThoughtIdDeleteData, DeleteThoughtApiV1UsersThoughtIdDeleteErrors, DeleteThoughtApiV1UsersThoughtIdDeleteResponses, DeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteData, DeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteErrors, DeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteResponses, DeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteData, DeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteErrors, DeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteResponses, EmailLoginApiV1AuthEmailLoginPostData, EmailLoginApiV1AuthEmailLoginPostErrors, EmailLoginApiV1AuthEmailLoginPostResponses, EmailLoginSendCodeApiV1AuthEmailLoginSendCodePostData, EmailLoginSendCodeApiV1AuthEmailLoginSendCodePostErrors, EmailLoginSendCodeApiV1AuthEmailLoginSendCodePostResponses, EmailSendCodeApiV1AuthEmailSendCodePostData, EmailSendCodeApiV1AuthEmailSendCodePostErrors, EmailSendCodeApiV1AuthEmailSendCodePostResponses, EmailVerifyCodeApiV1AuthEmailVerifyCodePostData, EmailVerifyCodeApiV1AuthEmailVerifyCodePostErrors, EmailVerifyCodeApiV1AuthEmailVerifyCodePostResponses, GetAdminApiV1AuthAdminAdminIdGetData, GetAdminApiV1AuthAdminAdminIdGetErrors, GetAdminApiV1AuthAdminAdminIdGetResponses, GetAiGeneratedThoughtsApiV1UsersAiGeneratedGetData, GetAiGeneratedThoughtsApiV1UsersAiGeneratedGetErrors, GetAiGeneratedThoughtsApiV1UsersAiGeneratedGetResponses, GetAnalyticsOverviewApiV1AnalyticsOverviewGetData, GetAnalyticsOverviewApiV1AnalyticsOverviewGetResponses, GetAvatarsApiV1AuthAvatarsGetData, GetAvatarsApiV1AuthAvatarsGetResponses, GetDotPlotApiV1AnalyticsAdminDotPlotGetData, GetDotPlotApiV1AnalyticsAdminDotPlotGetErrors, GetDotPlotApiV1AnalyticsAdminDotPlotGetResponses, GetDotPlotMetaApiV1AnalyticsAdminDotPlotMetaGetData, GetDotPlotMetaApiV1AnalyticsAdminDotPlotMetaGetResponses, GetEiLeaderboardApiV1AuthEiLeaderboardGetData, GetEiLeaderboardApiV1AuthEiLeaderboardGetErrors, GetEiLeaderboardApiV1AuthEiLeaderboardGetResponses, GetEiResultsApiV1AuthEiResultsGetData, GetEiResultsApiV1AuthEiResultsGetErrors, GetEiResultsApiV1AuthEiResultsGetResponses, GetEiTestApiV1AuthEiTestGetData, GetEiTestApiV1AuthEiTestGetErrors, GetEiTestApiV1AuthEiTestGetResponses, GetFeedApiV1AuthFeedGetData, GetFeedApiV1AuthFeedGetErrors, GetFeedApiV1AuthFeedGetResponses, GetFeedStatusApiV1AuthFeedStatusGetData, GetFeedStatusApiV1AuthFeedStatusGetErrors, GetFeedStatusApiV1AuthFeedStatusGetResponses, GetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetData, GetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetErrors, GetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetResponses, GetFriendshipAnalyticsApiV1AnalyticsFriendshipsGetData, GetFriendshipAnalyticsApiV1AnalyticsFriendshipsGetResponses, GetInviteContextApiV1AuthInviteContextGetData, GetInviteContextApiV1AuthInviteContextGetErrors, GetInviteContextApiV1AuthInviteContextGetResponses, GetLastMessageApiV1LuniLuniGetLastMessageGetData, GetLastMessageApiV1LuniLuniGetLastMessageGetErrors, GetLastMessageApiV1LuniLuniGetLastMessageGetResponses, GetLuniAnalyticsApiV1AnalyticsLuniGetData, GetLuniAnalyticsApiV1AnalyticsLuniGetResponses, GetPendingRequestsAnalyticsApiV1AnalyticsPendingRequestsGetData, GetPendingRequestsAnalyticsApiV1AnalyticsPendingRequestsGetResponses, GetPushTrackingApiV1AnalyticsAdminPushTrackingGetData, GetPushTrackingApiV1AnalyticsAdminPushTrackingGetErrors, GetPushTrackingApiV1AnalyticsAdminPushTrackingGetResponses, GetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetData, GetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetErrors, GetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetResponses, GetQotdCurrentApiV1AuthFeedQotdCurrentGetData, GetQotdCurrentApiV1AuthFeedQotdCurrentGetResponses, GetRankStatsApiV1RanksStatsGetData, GetRankStatsApiV1RanksStatsGetResponses, GetSystemMetricsApiV1AnalyticsSystemGetData, GetSystemMetricsApiV1AnalyticsSystemGetResponses, GetTelegramUserEndpointApiV1TelegramTelegramIdGetData, GetTelegramUserEndpointApiV1TelegramTelegramIdGetErrors, GetTelegramUserEndpointApiV1TelegramTelegramIdGetResponses, GetThoughtApiV1UsersThoughtIdGetData, GetThoughtApiV1UsersThoughtIdGetErrors, GetThoughtApiV1UsersThoughtIdGetResponses, GetThoughtsByDateApiV1UsersDateThoughtsDateGetData, GetThoughtsByDateApiV1UsersDateThoughtsDateGetErrors, GetThoughtsByDateApiV1UsersDateThoughtsDateGetResponses, GetUserAnalyticsApiV1AnalyticsUsersGetData, GetUserAnalyticsApiV1AnalyticsUsersGetResponses, GetUserCardsApiV1AuthUserUserIdCardsGetData, GetUserCardsApiV1AuthUserUserIdCardsGetErrors, GetUserCardsApiV1AuthUserUserIdCardsGetResponses, GetUserEiApiV1AuthUserUserIdEiGetData, GetUserEiApiV1AuthUserUserIdEiGetErrors, GetUserEiApiV1AuthUserUserIdEiGetResponses, GetUserInfoByIdApiV1AuthUserUserIdGetData, GetUserInfoByIdApiV1AuthUserUserIdGetErrors, GetUserInfoByIdApiV1AuthUserUserIdGetResponses, GetUserMessagesApiV1AuthUserCommunicationBoardGetData, GetUserMessagesApiV1AuthUserCommunicationBoardGetErrors, GetUserMessagesApiV1AuthUserCommunicationBoardGetResponses, GetUserPersonalityApiV1AuthUserUserIdPersonalityGetData, GetUserPersonalityApiV1AuthUserUserIdPersonalityGetErrors, GetUserPersonalityApiV1AuthUserUserIdPersonalityGetResponses, GetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetData, GetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetErrors, GetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetResponses, GetUserThoughtsApiV1UsersGetData, GetUserThoughtsApiV1UsersGetErrors, GetUserThoughtsApiV1UsersGetResponses, GetUserThoughtsByIdApiV1UsersUserIdThoughtsGetData, GetUserThoughtsByIdApiV1UsersUserIdThoughtsGetErrors, GetUserThoughtsByIdApiV1UsersUserIdThoughtsGetResponses, GetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetData, GetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetErrors, GetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetResponses, GetValidationQuestionApiV1LuniValidationQuestionUserIdGetData, GetValidationQuestionApiV1LuniValidationQuestionUserIdGetErrors, GetValidationQuestionApiV1LuniValidationQuestionUserIdGetResponses, GetWebappParamsApiV1AuthWebappParamsGetData, GetWebappParamsApiV1AuthWebappParamsGetResponses, GoogleLoginApiV1AuthGoogleLoginPostData, GoogleLoginApiV1AuthGoogleLoginPostErrors, GoogleLoginApiV1AuthGoogleLoginPostResponses, GoogleRtdnApiV1PaymentsGoogleRtdnPostData, GoogleRtdnApiV1PaymentsGoogleRtdnPostErrors, GoogleRtdnApiV1PaymentsGoogleRtdnPostResponses, GoogleRtdnV1PaymentsGoogleRtdnPostData, GoogleRtdnV1PaymentsGoogleRtdnPostErrors, GoogleRtdnV1PaymentsGoogleRtdnPostResponses, HealthCheckApiV1HealthGetData, HealthCheckApiV1HealthGetResponses, HealthCheckApiV1LuniHealthGetData, HealthCheckApiV1LuniHealthGetResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, HideCardApiV1AuthCardsCardIdHidePostData, HideCardApiV1AuthCardsCardIdHidePostErrors, HideCardApiV1AuthCardsCardIdHidePostResponses, LikeCardApiV1AuthCardsCardIdLikePostData, LikeCardApiV1AuthCardsCardIdLikePostErrors, LikeCardApiV1AuthCardsCardIdLikePostResponses, ListSessionsApiV1AuthSessionsGetData, ListSessionsApiV1AuthSessionsGetResponses, ListUsersApiV1AuthUsersGetData, ListUsersApiV1AuthUsersGetErrors, ListUsersApiV1AuthUsersGetResponses, LogoutApiV1AuthLogoutPostData, LogoutApiV1AuthLogoutPostErrors, LogoutApiV1AuthLogoutPostResponses, LuniMessageExchangeApiV1LuniLuniMessageExchangePostData, LuniMessageExchangeApiV1LuniLuniMessageExchangePostErrors, LuniMessageExchangeApiV1LuniLuniMessageExchangePostResponses, MarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostData, MarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostErrors, MarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostResponses, MarkThoughtAsReadApiV1UsersThoughtIdReadPatchData, MarkThoughtAsReadApiV1UsersThoughtIdReadPatchErrors, MarkThoughtAsReadApiV1UsersThoughtIdReadPatchResponses, PatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchData, PatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchErrors, PatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchResponses, PatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchData, PatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchErrors, PatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchResponses, PostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostData, PostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostErrors, PostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostResponses, PostQotdAnswerApiV1AuthFeedQotdAnswerPostData, PostQotdAnswerApiV1AuthFeedQotdAnswerPostErrors, PostQotdAnswerApiV1AuthFeedQotdAnswerPostResponses, RebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostData, RebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostErrors, RebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostResponses, RebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostData, RebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostErrors, RebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostResponses, RecordAppPageVisitApiV1AnalyticsPageVisitsAppPostData, RecordAppPageVisitApiV1AnalyticsPageVisitsAppPostResponses, RecordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPostData, RecordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPostResponses, RecordFeedPageVisitApiV1AnalyticsPageVisitsFeedPostData, RecordFeedPageVisitApiV1AnalyticsPageVisitsFeedPostResponses, RefreshTokenApiV1AuthTokenRefreshPostData, RefreshTokenApiV1AuthTokenRefreshPostErrors, RefreshTokenApiV1AuthTokenRefreshPostResponses, RegisterApiV1AuthRegisterPostData, RegisterApiV1AuthRegisterPostErrors, RegisterApiV1AuthRegisterPostResponses, RegisterDeviceTokenApiV1AuthDevicesTokenPostData, RegisterDeviceTokenApiV1AuthDevicesTokenPostErrors, RegisterDeviceTokenApiV1AuthDevicesTokenPostResponses, RegisterTelegramUserApiV1TelegramRegisterPostData, RegisterTelegramUserApiV1TelegramRegisterPostErrors, RegisterTelegramUserApiV1TelegramRegisterPostResponses, ReportCardApiV1AuthCardsCardIdReportPostData, ReportCardApiV1AuthCardsCardIdReportPostErrors, ReportCardApiV1AuthCardsCardIdReportPostResponses, RevokeAllSessionsEndpointApiV1AuthSessionsDeleteData, RevokeAllSessionsEndpointApiV1AuthSessionsDeleteResponses, RevokeSessionEndpointApiV1AuthSessionsIdDeleteData, RevokeSessionEndpointApiV1AuthSessionsIdDeleteErrors, RevokeSessionEndpointApiV1AuthSessionsIdDeleteResponses, RootApiV1GetData, RootApiV1GetResponses, RustoreServerNotificationsApiV1PaymentsRustoreNotificationsPostData, RustoreServerNotificationsApiV1PaymentsRustoreNotificationsPostErrors, RustoreServerNotificationsApiV1PaymentsRustoreNotificationsPostResponses, SaveEiAnswersApiV1AuthEiTestAnswersPutData, SaveEiAnswersApiV1AuthEiTestAnswersPutErrors, SaveEiAnswersApiV1AuthEiTestAnswersPutResponses, SaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostData, SaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostErrors, SaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostResponses, SaveOnboardingInstagramApiV1OnboardingInstagramPostData, SaveOnboardingInstagramApiV1OnboardingInstagramPostErrors, SaveOnboardingInstagramApiV1OnboardingInstagramPostResponses, SaveOnboardingIntentionApiV1OnboardingIntentionPostData, SaveOnboardingIntentionApiV1OnboardingIntentionPostErrors, SaveOnboardingIntentionApiV1OnboardingIntentionPostResponses, SaveOnboardingVpnApiV1OnboardingVpnPostData, SaveOnboardingVpnApiV1OnboardingVpnPostErrors, SaveOnboardingVpnApiV1OnboardingVpnPostResponses, SendSupportMessageApiV1SupportSendPostData, SendSupportMessageApiV1SupportSendPostErrors, SendSupportMessageApiV1SupportSendPostResponses, SetUserToUserMessagesDeliveredApiV1AuthSetUserToUserMessageDeliveredPostData, SetUserToUserMessagesDeliveredApiV1AuthSetUserToUserMessageDeliveredPostErrors, SetUserToUserMessagesDeliveredApiV1AuthSetUserToUserMessageDeliveredPostResponses, StarCardApiV1AuthCardsCardIdStarPostData, StarCardApiV1AuthCardsCardIdStarPostErrors, StarCardApiV1AuthCardsCardIdStarPostResponses, StartEiTestApiV1AuthEiTestStartPostData, StartEiTestApiV1AuthEiTestStartPostErrors, StartEiTestApiV1AuthEiTestStartPostResponses, StreamChatApiV1LuniStreamChatPostData, StreamChatApiV1LuniStreamChatPostErrors, StreamChatApiV1LuniStreamChatPostResponses, SubscriptionCancelApiV1SubscriptionCancelPostData, SubscriptionCancelApiV1SubscriptionCancelPostErrors, SubscriptionCancelApiV1SubscriptionCancelPostResponses, SubscriptionStatusApiV1SubscriptionStatusGetData, SubscriptionStatusApiV1SubscriptionStatusGetErrors, SubscriptionStatusApiV1SubscriptionStatusGetResponses, TranslateApiV1TranslatePostData, TranslateApiV1TranslatePostErrors, TranslateApiV1TranslatePostResponses, TrustGateConfirmApiV1AuthTrustGateConfirmPostData, TrustGateConfirmApiV1AuthTrustGateConfirmPostErrors, TrustGateConfirmApiV1AuthTrustGateConfirmPostResponses, TrustGateIssueLuniIdApiV1AuthTrustGateIssueLuniIdPostData, TrustGateIssueLuniIdApiV1AuthTrustGateIssueLuniIdPostResponses, TrustGateShownApiV1AuthTrustGateShownPostData, TrustGateShownApiV1AuthTrustGateShownPostResponses, TrustGateStatusApiV1AuthTrustGateStatusGetData, TrustGateStatusApiV1AuthTrustGateStatusGetResponses, UnblockUserEndpointApiV1AuthUserUserIdUnblockPostData, UnblockUserEndpointApiV1AuthUserUserIdUnblockPostErrors, UnblockUserEndpointApiV1AuthUserUserIdUnblockPostResponses, UnregisterDeviceTokenApiV1AuthDevicesTokenDeleteData, UnregisterDeviceTokenApiV1AuthDevicesTokenDeleteErrors, UnregisterDeviceTokenApiV1AuthDevicesTokenDeleteResponses, UpdateAdminApiV1AuthAdminAdminIdPutData, UpdateAdminApiV1AuthAdminAdminIdPutErrors, UpdateAdminApiV1AuthAdminAdminIdPutResponses, UpdateCardApiV1AuthUserUserIdCardsCardIdPutData, UpdateCardApiV1AuthUserUserIdCardsCardIdPutErrors, UpdateCardApiV1AuthUserUserIdCardsCardIdPutResponses, UpdateCheckApiV1AppUpdateCheckGetData, UpdateCheckApiV1AppUpdateCheckGetErrors, UpdateCheckApiV1AppUpdateCheckGetResponses, UpdateTelegramUserEndpointApiV1TelegramTelegramIdPutData, UpdateTelegramUserEndpointApiV1TelegramTelegramIdPutErrors, UpdateTelegramUserEndpointApiV1TelegramTelegramIdPutResponses, UpdateThoughtApiV1UsersThoughtIdPutData, UpdateThoughtApiV1UsersThoughtIdPutErrors, UpdateThoughtApiV1UsersThoughtIdPutResponses, UpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutData, UpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutErrors, UpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutResponses, UpdateUserApiV1AuthUpdateUserPostData, UpdateUserApiV1AuthUpdateUserPostErrors, UpdateUserApiV1AuthUpdateUserPostResponses, UpdateUserCommunicationBoardApiV1AuthUserCommunicationBoardPutData, UpdateUserCommunicationBoardApiV1AuthUserCommunicationBoardPutErrors, UpdateUserCommunicationBoardApiV1AuthUserCommunicationBoardPutResponses, ValidatePendingRepliesApiV1LuniValidatePendingRepliesPostData, ValidatePendingRepliesApiV1LuniValidatePendingRepliesPostErrors, ValidatePendingRepliesApiV1LuniValidatePendingRepliesPostResponses, VerifyPurchaseApiV1SubscriptionVerifyPurchasePostData, VerifyPurchaseApiV1SubscriptionVerifyPurchasePostErrors, VerifyPurchaseApiV1SubscriptionVerifyPurchasePostResponses } from './types.gen';
import { zAdminLoginApiV1AuthAdminLoginPostResponse, zAnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostResponse, zAppleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGetResponse, zAppleLoginApiV1AuthAppleLoginPostResponse, zAppleVerifyPurchaseApiV1PaymentsAppleVerifyPostResponse, zBlockUserEndpointApiV1AuthUserUserIdBlockPostResponse, zCharacterLastMessageApiV1CharacterCharacterLastMessageGetResponse, zCharacterSendMessageApiV1CharacterCharacterSendMessagePostResponse, zCharacterStreamApiV1CharacterCharacterStreamPostResponse, zCheckPhotoApiV1AuthCheckPhotoPostResponse, zCheckPhotoQualityApiV1AuthCheckPhotoQualityPostResponse, zCheckUserExistsApiV1AuthCheckUserPostResponse, zCompleteEiTestApiV1AuthEiTestCompletePostResponse, zCreateAdminApiV1AuthAdminCreatePostResponse, zCreateCardApiV1AuthUserUserIdCardsPostResponse, zCreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostResponse, zCreateThoughtApiV1UsersPostResponse, zCreateThoughtByUserIdApiV1UsersUserIdThoughtsPostResponse, zDeleteCardApiV1AuthUserUserIdCardsCardIdDeleteResponse, zDeleteThoughtApiV1UsersThoughtIdDeleteResponse, zDeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteResponse, zDeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteResponse, zEmailLoginApiV1AuthEmailLoginPostResponse, zEmailLoginSendCodeApiV1AuthEmailLoginSendCodePostResponse, zEmailSendCodeApiV1AuthEmailSendCodePostResponse, zEmailVerifyCodeApiV1AuthEmailVerifyCodePostResponse, zGetAdminApiV1AuthAdminAdminIdGetResponse, zGetAiGeneratedThoughtsApiV1UsersAiGeneratedGetResponse, zGetAvatarsApiV1AuthAvatarsGetResponse, zGetDotPlotApiV1AnalyticsAdminDotPlotGetResponse, zGetDotPlotMetaApiV1AnalyticsAdminDotPlotMetaGetResponse, zGetEiLeaderboardApiV1AuthEiLeaderboardGetResponse, zGetEiResultsApiV1AuthEiResultsGetResponse, zGetEiTestApiV1AuthEiTestGetResponse, zGetFeedApiV1AuthFeedGetResponse, zGetFeedStatusApiV1AuthFeedStatusGetResponse, zGetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetResponse, zGetFriendshipAnalyticsApiV1AnalyticsFriendshipsGetResponse, zGetInviteContextApiV1AuthInviteContextGetResponse, zGetLastMessageApiV1LuniLuniGetLastMessageGetResponse, zGetLuniAnalyticsApiV1AnalyticsLuniGetResponse, zGetPendingRequestsAnalyticsApiV1AnalyticsPendingRequestsGetResponse, zGetPushTrackingApiV1AnalyticsAdminPushTrackingGetResponse, zGetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetResponse, zGetQotdCurrentApiV1AuthFeedQotdCurrentGetResponse, zGetRankStatsApiV1RanksStatsGetResponse, zGetSystemMetricsApiV1AnalyticsSystemGetResponse, zGetTelegramUserEndpointApiV1TelegramTelegramIdGetResponse, zGetThoughtApiV1UsersThoughtIdGetResponse, zGetThoughtsByDateApiV1UsersDateThoughtsDateGetResponse, zGetUserAnalyticsApiV1AnalyticsUsersGetResponse, zGetUserCardsApiV1AuthUserUserIdCardsGetResponse, zGetUserEiApiV1AuthUserUserIdEiGetResponse, zGetUserInfoByIdApiV1AuthUserUserIdGetResponse, zGetUserPersonalityApiV1AuthUserUserIdPersonalityGetResponse, zGetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetResponse, zGetUserThoughtsApiV1UsersGetResponse, zGetUserThoughtsByIdApiV1UsersUserIdThoughtsGetResponse, zGetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetResponse, zGetValidationQuestionApiV1LuniValidationQuestionUserIdGetResponse, zGoogleLoginApiV1AuthGoogleLoginPostResponse, zHideCardApiV1AuthCardsCardIdHidePostResponse, zLikeCardApiV1AuthCardsCardIdLikePostResponse, zListSessionsApiV1AuthSessionsGetResponse, zListUsersApiV1AuthUsersGetResponse, zLogoutApiV1AuthLogoutPostResponse, zLuniMessageExchangeApiV1LuniLuniMessageExchangePostResponse, zMarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostResponse, zMarkThoughtAsReadApiV1UsersThoughtIdReadPatchResponse, zPatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchResponse, zPatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchResponse, zPostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostResponse, zPostQotdAnswerApiV1AuthFeedQotdAnswerPostResponse, zRebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostResponse, zRebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostResponse, zRecordAppPageVisitApiV1AnalyticsPageVisitsAppPostResponse, zRecordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPostResponse, zRecordFeedPageVisitApiV1AnalyticsPageVisitsFeedPostResponse, zRefreshTokenApiV1AuthTokenRefreshPostResponse, zRegisterApiV1AuthRegisterPostResponse, zRegisterDeviceTokenApiV1AuthDevicesTokenPostResponse, zRegisterTelegramUserApiV1TelegramRegisterPostResponse, zReportCardApiV1AuthCardsCardIdReportPostResponse, zRevokeAllSessionsEndpointApiV1AuthSessionsDeleteResponse, zRevokeSessionEndpointApiV1AuthSessionsIdDeleteResponse, zSaveEiAnswersApiV1AuthEiTestAnswersPutResponse, zSaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostResponse, zSaveOnboardingInstagramApiV1OnboardingInstagramPostResponse, zSaveOnboardingIntentionApiV1OnboardingIntentionPostResponse, zSaveOnboardingVpnApiV1OnboardingVpnPostResponse, zSendSupportMessageApiV1SupportSendPostResponse, zStarCardApiV1AuthCardsCardIdStarPostResponse, zStartEiTestApiV1AuthEiTestStartPostResponse, zSubscriptionCancelApiV1SubscriptionCancelPostResponse, zSubscriptionStatusApiV1SubscriptionStatusGetResponse, zTranslateApiV1TranslatePostResponse, zTrustGateConfirmApiV1AuthTrustGateConfirmPostResponse, zTrustGateIssueLuniIdApiV1AuthTrustGateIssueLuniIdPostResponse, zTrustGateShownApiV1AuthTrustGateShownPostResponse, zTrustGateStatusApiV1AuthTrustGateStatusGetResponse, zUnblockUserEndpointApiV1AuthUserUserIdUnblockPostResponse, zUnregisterDeviceTokenApiV1AuthDevicesTokenDeleteResponse, zUpdateAdminApiV1AuthAdminAdminIdPutResponse, zUpdateCardApiV1AuthUserUserIdCardsCardIdPutResponse, zUpdateCheckApiV1AppUpdateCheckGetResponse, zUpdateTelegramUserEndpointApiV1TelegramTelegramIdPutResponse, zUpdateThoughtApiV1UsersThoughtIdPutResponse, zUpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutResponse, zUpdateUserApiV1AuthUpdateUserPostResponse, zValidatePendingRepliesApiV1LuniValidatePendingRepliesPostResponse, zVerifyPurchaseApiV1SubscriptionVerifyPurchasePostResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Check whether the client must update before using the app
 *
 * Same floor as check_user, available before registration.
 */
export const updateCheckApiV1AppUpdateCheckGet = <ThrowOnError extends boolean = true>(options?: Options<UpdateCheckApiV1AppUpdateCheckGetData, ThrowOnError>): RequestResult<UpdateCheckApiV1AppUpdateCheckGetResponses, UpdateCheckApiV1AppUpdateCheckGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<UpdateCheckApiV1AppUpdateCheckGetResponses, UpdateCheckApiV1AppUpdateCheckGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateCheckApiV1AppUpdateCheckGetResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/app/update_check',
    ...options
});

/**
 * Register
 *
 * Register a new user.
 *
 * Classic email signup: user is created blocked until they verify the code
 * (backend sends the code here).
 *
 * Apple/Google signup: ``google_id_token`` or ``apple_identity_token`` (+
 * ``apple_nonce``) is re-verified; failures map to 401 / 503 like the login
 * endpoints. Email already taken maps to 409.
 */
export const registerApiV1AuthRegisterPost = <ThrowOnError extends boolean = true>(options: Options<RegisterApiV1AuthRegisterPostData, ThrowOnError>): RequestResult<RegisterApiV1AuthRegisterPostResponses, RegisterApiV1AuthRegisterPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<RegisterApiV1AuthRegisterPostResponses, RegisterApiV1AuthRegisterPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRegisterApiV1AuthRegisterPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check User Exists
 *
 * Check if user exists by Telegram ID.
 */
export const checkUserExistsApiV1AuthCheckUserPost = <ThrowOnError extends boolean = true>(options: Options<CheckUserExistsApiV1AuthCheckUserPostData, ThrowOnError>): RequestResult<CheckUserExistsApiV1AuthCheckUserPostResponses, CheckUserExistsApiV1AuthCheckUserPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CheckUserExistsApiV1AuthCheckUserPostResponses, CheckUserExistsApiV1AuthCheckUserPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCheckUserExistsApiV1AuthCheckUserPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/auth/check_user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email Send Code
 *
 * Send 4-digit verification code to email.
 *
 * Public endpoint (registration): behaves as before, with rate limits.
 * Authenticated user (profile): used for email change flow with extra checks:
 * - 409 if new email == current email
 * - 409 if email is already registered to another user
 * - send warning email to old address (if present) about email change attempt
 * - send verification code to new email
 */
export const emailSendCodeApiV1AuthEmailSendCodePost = <ThrowOnError extends boolean = true>(options: Options<EmailSendCodeApiV1AuthEmailSendCodePostData, ThrowOnError>): RequestResult<EmailSendCodeApiV1AuthEmailSendCodePostResponses, EmailSendCodeApiV1AuthEmailSendCodePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<EmailSendCodeApiV1AuthEmailSendCodePostResponses, EmailSendCodeApiV1AuthEmailSendCodePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zEmailSendCodeApiV1AuthEmailSendCodePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/email/send-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email Verify Code
 *
 * Verify 4-digit code for email.
 *
 * Two flows:
 * - Signup registration: verifies code and moves user to ``need_age_verification``.
 * - Authenticated profile email change: if there is pending email change for current user
 * and email matches pending one, then on successful verification we update user's email
 * in DB (no registration block).
 */
export const emailVerifyCodeApiV1AuthEmailVerifyCodePost = <ThrowOnError extends boolean = true>(options: Options<EmailVerifyCodeApiV1AuthEmailVerifyCodePostData, ThrowOnError>): RequestResult<EmailVerifyCodeApiV1AuthEmailVerifyCodePostResponses, EmailVerifyCodeApiV1AuthEmailVerifyCodePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<EmailVerifyCodeApiV1AuthEmailVerifyCodePostResponses, EmailVerifyCodeApiV1AuthEmailVerifyCodePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zEmailVerifyCodeApiV1AuthEmailVerifyCodePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/email/verify-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email Login Send Code
 *
 * Send verification code for **existing** users only (mobile email login).
 *
 * Unlike ``/email/send-code``, returns 404 if no account is registered for this email.
 */
export const emailLoginSendCodeApiV1AuthEmailLoginSendCodePost = <ThrowOnError extends boolean = true>(options: Options<EmailLoginSendCodeApiV1AuthEmailLoginSendCodePostData, ThrowOnError>): RequestResult<EmailLoginSendCodeApiV1AuthEmailLoginSendCodePostResponses, EmailLoginSendCodeApiV1AuthEmailLoginSendCodePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<EmailLoginSendCodeApiV1AuthEmailLoginSendCodePostResponses, EmailLoginSendCodeApiV1AuthEmailLoginSendCodePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zEmailLoginSendCodeApiV1AuthEmailLoginSendCodePostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/auth/email/login/send-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email Login
 *
 * Verify email code and log in: JWT + user profile (registered users only).
 *
 * Use after ``POST /email/login/send-code``. Same 4-digit code flow as registration,
 * but requires an existing account and returns tokens like ``check_user``.
 */
export const emailLoginApiV1AuthEmailLoginPost = <ThrowOnError extends boolean = true>(options: Options<EmailLoginApiV1AuthEmailLoginPostData, ThrowOnError>): RequestResult<EmailLoginApiV1AuthEmailLoginPostResponses, EmailLoginApiV1AuthEmailLoginPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<EmailLoginApiV1AuthEmailLoginPostResponses, EmailLoginApiV1AuthEmailLoginPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zEmailLoginApiV1AuthEmailLoginPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/auth/email/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apple Login
 *
 * Native Sign in with Apple: verify identity_token, exchange code, return UserCheckResponse.
 *
 * Resolves the account by the ``(apple, sub)`` link, falling back to the token's
 * ``email`` when ``email_verified`` is set — including a private-relay address, which
 * matches whenever the account was registered with that same relay.
 *
 * When ``exists=false`` nothing matched and the client continues to onboarding; the
 * link is created later via ``POST /register`` with ``apple_identity_token``.
 */
export const appleLoginApiV1AuthAppleLoginPost = <ThrowOnError extends boolean = true>(options: Options<AppleLoginApiV1AuthAppleLoginPostData, ThrowOnError>): RequestResult<AppleLoginApiV1AuthAppleLoginPostResponses, AppleLoginApiV1AuthAppleLoginPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AppleLoginApiV1AuthAppleLoginPostResponses, AppleLoginApiV1AuthAppleLoginPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zAppleLoginApiV1AuthAppleLoginPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/auth/apple/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Google Login
 *
 * Native Sign in with Google: verify id_token, return UserCheckResponse.
 *
 * Resolves the account by the ``(google, sub)`` link, falling back to the token's
 * ``email`` when ``email_verified`` is set: an account registered before the link
 * existed is adopted and linked here, so it signs in instead of being sent to
 * registration with an address that is already taken.
 *
 * When ``exists=false`` nothing matched and the client continues to onboarding; the
 * link is created later via ``POST /register`` with ``google_id_token``.
 */
export const googleLoginApiV1AuthGoogleLoginPost = <ThrowOnError extends boolean = true>(options: Options<GoogleLoginApiV1AuthGoogleLoginPostData, ThrowOnError>): RequestResult<GoogleLoginApiV1AuthGoogleLoginPostResponses, GoogleLoginApiV1AuthGoogleLoginPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<GoogleLoginApiV1AuthGoogleLoginPostResponses, GoogleLoginApiV1AuthGoogleLoginPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGoogleLoginApiV1AuthGoogleLoginPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/auth/google/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Login
 *
 * Admin login.
 */
export const adminLoginApiV1AuthAdminLoginPost = <ThrowOnError extends boolean = true>(options: Options<AdminLoginApiV1AuthAdminLoginPostData, ThrowOnError>): RequestResult<AdminLoginApiV1AuthAdminLoginPostResponses, AdminLoginApiV1AuthAdminLoginPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AdminLoginApiV1AuthAdminLoginPostResponses, AdminLoginApiV1AuthAdminLoginPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zAdminLoginApiV1AuthAdminLoginPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/auth/admin/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Token
 *
 * Refresh access token.
 */
export const refreshTokenApiV1AuthTokenRefreshPost = <ThrowOnError extends boolean = true>(options: Options<RefreshTokenApiV1AuthTokenRefreshPostData, ThrowOnError>): RequestResult<RefreshTokenApiV1AuthTokenRefreshPostResponses, RefreshTokenApiV1AuthTokenRefreshPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<RefreshTokenApiV1AuthTokenRefreshPostResponses, RefreshTokenApiV1AuthTokenRefreshPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRefreshTokenApiV1AuthTokenRefreshPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/auth/token/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout
 *
 * Revoke the session for the given refresh token (and optionally this device).
 */
export const logoutApiV1AuthLogoutPost = <ThrowOnError extends boolean = true>(options: Options<LogoutApiV1AuthLogoutPostData, ThrowOnError>): RequestResult<LogoutApiV1AuthLogoutPostResponses, LogoutApiV1AuthLogoutPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LogoutApiV1AuthLogoutPostResponses, LogoutApiV1AuthLogoutPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLogoutApiV1AuthLogoutPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke All Sessions Endpoint
 *
 * Revoke all sessions for current user.
 */
export const revokeAllSessionsEndpointApiV1AuthSessionsDelete = <ThrowOnError extends boolean = true>(options?: Options<RevokeAllSessionsEndpointApiV1AuthSessionsDeleteData, ThrowOnError>): RequestResult<RevokeAllSessionsEndpointApiV1AuthSessionsDeleteResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).delete<RevokeAllSessionsEndpointApiV1AuthSessionsDeleteResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRevokeAllSessionsEndpointApiV1AuthSessionsDeleteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/sessions',
    ...options
});

/**
 * List Sessions
 *
 * List active sessions for current user.
 */
export const listSessionsApiV1AuthSessionsGet = <ThrowOnError extends boolean = true>(options?: Options<ListSessionsApiV1AuthSessionsGetData, ThrowOnError>): RequestResult<ListSessionsApiV1AuthSessionsGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<ListSessionsApiV1AuthSessionsGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zListSessionsApiV1AuthSessionsGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/sessions',
    ...options
});

/**
 * Revoke Session Endpoint
 *
 * Revoke one session for current user by numeric session row id.
 */
export const revokeSessionEndpointApiV1AuthSessionsIdDelete = <ThrowOnError extends boolean = true>(options: Options<RevokeSessionEndpointApiV1AuthSessionsIdDeleteData, ThrowOnError>): RequestResult<RevokeSessionEndpointApiV1AuthSessionsIdDeleteResponses, RevokeSessionEndpointApiV1AuthSessionsIdDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<RevokeSessionEndpointApiV1AuthSessionsIdDeleteResponses, RevokeSessionEndpointApiV1AuthSessionsIdDeleteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRevokeSessionEndpointApiV1AuthSessionsIdDeleteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/sessions/{id}',
    ...options
});

/**
 * List Users
 *
 * Get users list with filters (requires USER_READ permission).
 */
export const listUsersApiV1AuthUsersGet = <ThrowOnError extends boolean = true>(options?: Options<ListUsersApiV1AuthUsersGetData, ThrowOnError>): RequestResult<ListUsersApiV1AuthUsersGetResponses, ListUsersApiV1AuthUsersGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ListUsersApiV1AuthUsersGetResponses, ListUsersApiV1AuthUsersGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zListUsersApiV1AuthUsersGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/users',
    ...options
});

/**
 * Get User Info By Id
 *
 * Get own user profile. Other user ids are forbidden.
 */
export const getUserInfoByIdApiV1AuthUserUserIdGet = <ThrowOnError extends boolean = true>(options: Options<GetUserInfoByIdApiV1AuthUserUserIdGetData, ThrowOnError>): RequestResult<GetUserInfoByIdApiV1AuthUserUserIdGetResponses, GetUserInfoByIdApiV1AuthUserUserIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetUserInfoByIdApiV1AuthUserUserIdGetResponses, GetUserInfoByIdApiV1AuthUserUserIdGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserInfoByIdApiV1AuthUserUserIdGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}',
    ...options
});

/**
 * Update User
 *
 * Update user profile.
 */
export const updateUserApiV1AuthUpdateUserPost = <ThrowOnError extends boolean = true>(options: Options<UpdateUserApiV1AuthUpdateUserPostData, ThrowOnError>): RequestResult<UpdateUserApiV1AuthUpdateUserPostResponses, UpdateUserApiV1AuthUpdateUserPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<UpdateUserApiV1AuthUpdateUserPostResponses, UpdateUserApiV1AuthUpdateUserPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateUserApiV1AuthUpdateUserPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/update_user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trust Gate Issue Luni Id
 *
 * Выдать/вернуть Luni-ID и отдать полный UserOut (как в check_user).
 */
export const trustGateIssueLuniIdApiV1AuthTrustGateIssueLuniIdPost = <ThrowOnError extends boolean = true>(options?: Options<TrustGateIssueLuniIdApiV1AuthTrustGateIssueLuniIdPostData, ThrowOnError>): RequestResult<TrustGateIssueLuniIdApiV1AuthTrustGateIssueLuniIdPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<TrustGateIssueLuniIdApiV1AuthTrustGateIssueLuniIdPostResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zTrustGateIssueLuniIdApiV1AuthTrustGateIssueLuniIdPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/trust-gate/issue-luni-id',
    ...options
});

/**
 * Trust Gate Status
 *
 * Проверить, снят ли трастгейт (друг, таймаут, social match или миграция).
 */
export const trustGateStatusApiV1AuthTrustGateStatusGet = <ThrowOnError extends boolean = true>(options?: Options<TrustGateStatusApiV1AuthTrustGateStatusGetData, ThrowOnError>): RequestResult<TrustGateStatusApiV1AuthTrustGateStatusGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<TrustGateStatusApiV1AuthTrustGateStatusGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zTrustGateStatusApiV1AuthTrustGateStatusGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/trust-gate/status',
    ...options
});

/**
 * Trust Gate Shown
 *
 * First trust-gate popup impression; starts the auto-lift clock.
 */
export const trustGateShownApiV1AuthTrustGateShownPost = <ThrowOnError extends boolean = true>(options?: Options<TrustGateShownApiV1AuthTrustGateShownPostData, ThrowOnError>): RequestResult<TrustGateShownApiV1AuthTrustGateShownPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<TrustGateShownApiV1AuthTrustGateShownPostResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zTrustGateShownApiV1AuthTrustGateShownPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/trust-gate/shown',
    ...options
});

/**
 * Trust Gate Confirm
 *
 * Публичный trust-gate: подтверждение по ссылке с luni_id + имя/email подтверждающего.
 */
export const trustGateConfirmApiV1AuthTrustGateConfirmPost = <ThrowOnError extends boolean = true>(options: Options<TrustGateConfirmApiV1AuthTrustGateConfirmPostData, ThrowOnError>): RequestResult<TrustGateConfirmApiV1AuthTrustGateConfirmPostResponses, TrustGateConfirmApiV1AuthTrustGateConfirmPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<TrustGateConfirmApiV1AuthTrustGateConfirmPostResponses, TrustGateConfirmApiV1AuthTrustGateConfirmPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zTrustGateConfirmApiV1AuthTrustGateConfirmPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/trust-gate/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unregister Device Token
 *
 * Unlink FCM token(s) for the current user's device. Idempotent.
 */
export const unregisterDeviceTokenApiV1AuthDevicesTokenDelete = <ThrowOnError extends boolean = true>(options: Options<UnregisterDeviceTokenApiV1AuthDevicesTokenDeleteData, ThrowOnError>): RequestResult<UnregisterDeviceTokenApiV1AuthDevicesTokenDeleteResponses, UnregisterDeviceTokenApiV1AuthDevicesTokenDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<UnregisterDeviceTokenApiV1AuthDevicesTokenDeleteResponses, UnregisterDeviceTokenApiV1AuthDevicesTokenDeleteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUnregisterDeviceTokenApiV1AuthDevicesTokenDeleteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/devices/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register Device Token
 *
 * Register/update FCM token for current user device.
 */
export const registerDeviceTokenApiV1AuthDevicesTokenPost = <ThrowOnError extends boolean = true>(options: Options<RegisterDeviceTokenApiV1AuthDevicesTokenPostData, ThrowOnError>): RequestResult<RegisterDeviceTokenApiV1AuthDevicesTokenPostResponses, RegisterDeviceTokenApiV1AuthDevicesTokenPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<RegisterDeviceTokenApiV1AuthDevicesTokenPostResponses, RegisterDeviceTokenApiV1AuthDevicesTokenPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRegisterDeviceTokenApiV1AuthDevicesTokenPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/devices/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Photo
 *
 * Selfie check. Bearer required. Body is ``{image, attempt_id}`` only.
 */
export const checkPhotoApiV1AuthCheckPhotoPost = <ThrowOnError extends boolean = true>(options: Options<CheckPhotoApiV1AuthCheckPhotoPostData, ThrowOnError>): RequestResult<CheckPhotoApiV1AuthCheckPhotoPostResponses, CheckPhotoApiV1AuthCheckPhotoPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CheckPhotoApiV1AuthCheckPhotoPostResponses, CheckPhotoApiV1AuthCheckPhotoPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCheckPhotoApiV1AuthCheckPhotoPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/check_photo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Photo Quality
 *
 * Check photo quality.
 */
export const checkPhotoQualityApiV1AuthCheckPhotoQualityPost = <ThrowOnError extends boolean = true>(options: Options<CheckPhotoQualityApiV1AuthCheckPhotoQualityPostData, ThrowOnError>): RequestResult<CheckPhotoQualityApiV1AuthCheckPhotoQualityPostResponses, CheckPhotoQualityApiV1AuthCheckPhotoQualityPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CheckPhotoQualityApiV1AuthCheckPhotoQualityPostResponses, CheckPhotoQualityApiV1AuthCheckPhotoQualityPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCheckPhotoQualityApiV1AuthCheckPhotoQualityPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/auth/check_photo_quality',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Block User Endpoint
 *
 * Block another user (social). Does not ban account or revoke VPN.
 */
export const blockUserEndpointApiV1AuthUserUserIdBlockPost = <ThrowOnError extends boolean = true>(options: Options<BlockUserEndpointApiV1AuthUserUserIdBlockPostData, ThrowOnError>): RequestResult<BlockUserEndpointApiV1AuthUserUserIdBlockPostResponses, BlockUserEndpointApiV1AuthUserUserIdBlockPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<BlockUserEndpointApiV1AuthUserUserIdBlockPostResponses, BlockUserEndpointApiV1AuthUserUserIdBlockPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zBlockUserEndpointApiV1AuthUserUserIdBlockPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/block',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unblock User Endpoint
 *
 * Unblock another user (social). Does not affect VPN.
 */
export const unblockUserEndpointApiV1AuthUserUserIdUnblockPost = <ThrowOnError extends boolean = true>(options: Options<UnblockUserEndpointApiV1AuthUserUserIdUnblockPostData, ThrowOnError>): RequestResult<UnblockUserEndpointApiV1AuthUserUserIdUnblockPostResponses, UnblockUserEndpointApiV1AuthUserUserIdUnblockPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<UnblockUserEndpointApiV1AuthUserUserIdUnblockPostResponses, UnblockUserEndpointApiV1AuthUserUserIdUnblockPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUnblockUserEndpointApiV1AuthUserUserIdUnblockPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/unblock',
    ...options
});

/**
 * Delete User Endpoint
 *
 * Delete own account.
 *
 * Optional JSON body: ``{"reason": "..."}`` — stored in ``user_removals.removal_reason``.
 */
export const deleteUserEndpointApiV1AuthUserDeleteUserIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteData, ThrowOnError>): RequestResult<DeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteResponses, DeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteResponses, DeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteUserEndpointApiV1AuthUserDeleteUserIdDeleteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/delete/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Count Open Friend Requests
 *
 * Count open friend requests for the authenticated user only.
 */
export const countOpenFriendRequestsApiV1AuthUserCountOpenFriendRequestsUserIdGet = <ThrowOnError extends boolean = true>(options: Options<CountOpenFriendRequestsApiV1AuthUserCountOpenFriendRequestsUserIdGetData, ThrowOnError>): RequestResult<CountOpenFriendRequestsApiV1AuthUserCountOpenFriendRequestsUserIdGetResponses, CountOpenFriendRequestsApiV1AuthUserCountOpenFriendRequestsUserIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<CountOpenFriendRequestsApiV1AuthUserCountOpenFriendRequestsUserIdGetResponses, CountOpenFriendRequestsApiV1AuthUserCountOpenFriendRequestsUserIdGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/count_open_friend_requests/{user_id}',
    ...options
});

/**
 * Get User Messages
 *
 * Get user communication board (caller must be a participant).
 */
export const getUserMessagesApiV1AuthUserCommunicationBoardGet = <ThrowOnError extends boolean = true>(options: Options<GetUserMessagesApiV1AuthUserCommunicationBoardGetData, ThrowOnError>): RequestResult<GetUserMessagesApiV1AuthUserCommunicationBoardGetResponses, GetUserMessagesApiV1AuthUserCommunicationBoardGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetUserMessagesApiV1AuthUserCommunicationBoardGetResponses, GetUserMessagesApiV1AuthUserCommunicationBoardGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user_communication_board',
    ...options
});

/**
 * Update User Communication Board
 *
 * Update communication board status (caller must be a participant).
 */
export const updateUserCommunicationBoardApiV1AuthUserCommunicationBoardPut = <ThrowOnError extends boolean = true>(options: Options<UpdateUserCommunicationBoardApiV1AuthUserCommunicationBoardPutData, ThrowOnError>): RequestResult<UpdateUserCommunicationBoardApiV1AuthUserCommunicationBoardPutResponses, UpdateUserCommunicationBoardApiV1AuthUserCommunicationBoardPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<UpdateUserCommunicationBoardApiV1AuthUserCommunicationBoardPutResponses, UpdateUserCommunicationBoardApiV1AuthUserCommunicationBoardPutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user_communication_board',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set User To User Messages Delivered
 *
 * Set message as delivered (caller must be a participant).
 */
export const setUserToUserMessagesDeliveredApiV1AuthSetUserToUserMessageDeliveredPost = <ThrowOnError extends boolean = true>(options: Options<SetUserToUserMessagesDeliveredApiV1AuthSetUserToUserMessageDeliveredPostData, ThrowOnError>): RequestResult<SetUserToUserMessagesDeliveredApiV1AuthSetUserToUserMessageDeliveredPostResponses, SetUserToUserMessagesDeliveredApiV1AuthSetUserToUserMessageDeliveredPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SetUserToUserMessagesDeliveredApiV1AuthSetUserToUserMessageDeliveredPostResponses, SetUserToUserMessagesDeliveredApiV1AuthSetUserToUserMessageDeliveredPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/set_user_to_user_message_delivered',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Invite Context
 *
 * Get invite context by referral code.
 */
export const getInviteContextApiV1AuthInviteContextGet = <ThrowOnError extends boolean = true>(options: Options<GetInviteContextApiV1AuthInviteContextGetData, ThrowOnError>): RequestResult<GetInviteContextApiV1AuthInviteContextGetResponses, GetInviteContextApiV1AuthInviteContextGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetInviteContextApiV1AuthInviteContextGetResponses, GetInviteContextApiV1AuthInviteContextGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetInviteContextApiV1AuthInviteContextGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/invite_context',
    ...options
});

/**
 * Get Webapp Params
 *
 * Get webapp parameters.
 */
export const getWebappParamsApiV1AuthWebappParamsGet = <ThrowOnError extends boolean = true>(options?: Options<GetWebappParamsApiV1AuthWebappParamsGetData, ThrowOnError>): RequestResult<GetWebappParamsApiV1AuthWebappParamsGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetWebappParamsApiV1AuthWebappParamsGetResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/webapp_params',
    ...options
});

/**
 * Create Admin
 *
 * Create new admin (requires ADMIN_WRITE permission).
 */
export const createAdminApiV1AuthAdminCreatePost = <ThrowOnError extends boolean = true>(options: Options<CreateAdminApiV1AuthAdminCreatePostData, ThrowOnError>): RequestResult<CreateAdminApiV1AuthAdminCreatePostResponses, CreateAdminApiV1AuthAdminCreatePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CreateAdminApiV1AuthAdminCreatePostResponses, CreateAdminApiV1AuthAdminCreatePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateAdminApiV1AuthAdminCreatePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/admin/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Admin
 *
 * Get admin by ID (requires ADMIN_READ permission).
 */
export const getAdminApiV1AuthAdminAdminIdGet = <ThrowOnError extends boolean = true>(options: Options<GetAdminApiV1AuthAdminAdminIdGetData, ThrowOnError>): RequestResult<GetAdminApiV1AuthAdminAdminIdGetResponses, GetAdminApiV1AuthAdminAdminIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetAdminApiV1AuthAdminAdminIdGetResponses, GetAdminApiV1AuthAdminAdminIdGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetAdminApiV1AuthAdminAdminIdGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/admin/{admin_id}',
    ...options
});

/**
 * Update Admin
 *
 * Update admin (requires ADMIN_WRITE permission).
 */
export const updateAdminApiV1AuthAdminAdminIdPut = <ThrowOnError extends boolean = true>(options: Options<UpdateAdminApiV1AuthAdminAdminIdPutData, ThrowOnError>): RequestResult<UpdateAdminApiV1AuthAdminAdminIdPutResponses, UpdateAdminApiV1AuthAdminAdminIdPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<UpdateAdminApiV1AuthAdminAdminIdPutResponses, UpdateAdminApiV1AuthAdminAdminIdPutErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateAdminApiV1AuthAdminAdminIdPutResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/admin/{admin_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Cards
 *
 * Get cards for a user. Own profile: each card has **likes** (list of likers). Other's profile: **count_likes** and **current_user_liked** (no likes list).
 */
export const getUserCardsApiV1AuthUserUserIdCardsGet = <ThrowOnError extends boolean = true>(options: Options<GetUserCardsApiV1AuthUserUserIdCardsGetData, ThrowOnError>): RequestResult<GetUserCardsApiV1AuthUserUserIdCardsGetResponses, GetUserCardsApiV1AuthUserUserIdCardsGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetUserCardsApiV1AuthUserUserIdCardsGetResponses, GetUserCardsApiV1AuthUserUserIdCardsGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserCardsApiV1AuthUserUserIdCardsGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/cards',
    ...options
});

/**
 * Create Card
 *
 * Create a card. Allowed only for own profile (user_id must match current user).
 */
export const createCardApiV1AuthUserUserIdCardsPost = <ThrowOnError extends boolean = true>(options: Options<CreateCardApiV1AuthUserUserIdCardsPostData, ThrowOnError>): RequestResult<CreateCardApiV1AuthUserUserIdCardsPostResponses, CreateCardApiV1AuthUserUserIdCardsPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CreateCardApiV1AuthUserUserIdCardsPostResponses, CreateCardApiV1AuthUserUserIdCardsPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateCardApiV1AuthUserUserIdCardsPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Card
 *
 * Delete a card. Allowed only for card owner.
 */
export const deleteCardApiV1AuthUserUserIdCardsCardIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteCardApiV1AuthUserUserIdCardsCardIdDeleteData, ThrowOnError>): RequestResult<DeleteCardApiV1AuthUserUserIdCardsCardIdDeleteResponses, DeleteCardApiV1AuthUserUserIdCardsCardIdDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DeleteCardApiV1AuthUserUserIdCardsCardIdDeleteResponses, DeleteCardApiV1AuthUserUserIdCardsCardIdDeleteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteCardApiV1AuthUserUserIdCardsCardIdDeleteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/cards/{card_id}',
    ...options
});

/**
 * Update Card
 *
 * Update a card. Allowed only for card owner. Send only fields to change.
 */
export const updateCardApiV1AuthUserUserIdCardsCardIdPut = <ThrowOnError extends boolean = true>(options: Options<UpdateCardApiV1AuthUserUserIdCardsCardIdPutData, ThrowOnError>): RequestResult<UpdateCardApiV1AuthUserUserIdCardsCardIdPutResponses, UpdateCardApiV1AuthUserUserIdCardsCardIdPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<UpdateCardApiV1AuthUserUserIdCardsCardIdPutResponses, UpdateCardApiV1AuthUserUserIdCardsCardIdPutErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateCardApiV1AuthUserUserIdCardsCardIdPutResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/cards/{card_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Like Card
 *
 * Like a friend's or pending match's card. One like per user per card; cannot like own card. Idempotent: second like returns 409.
 */
export const likeCardApiV1AuthCardsCardIdLikePost = <ThrowOnError extends boolean = true>(options: Options<LikeCardApiV1AuthCardsCardIdLikePostData, ThrowOnError>): RequestResult<LikeCardApiV1AuthCardsCardIdLikePostResponses, LikeCardApiV1AuthCardsCardIdLikePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LikeCardApiV1AuthCardsCardIdLikePostResponses, LikeCardApiV1AuthCardsCardIdLikePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLikeCardApiV1AuthCardsCardIdLikePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/cards/{card_id}/like',
    ...options
});

/**
 * Star Card
 *
 * Star a card (feed or QOTD answer). Anonymous; one star per user; cannot star own card.
 */
export const starCardApiV1AuthCardsCardIdStarPost = <ThrowOnError extends boolean = true>(options: Options<StarCardApiV1AuthCardsCardIdStarPostData, ThrowOnError>): RequestResult<StarCardApiV1AuthCardsCardIdStarPostResponses, StarCardApiV1AuthCardsCardIdStarPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<StarCardApiV1AuthCardsCardIdStarPostResponses, StarCardApiV1AuthCardsCardIdStarPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zStarCardApiV1AuthCardsCardIdStarPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/cards/{card_id}/star',
    ...options
});

/**
 * Hide Card
 *
 * Hide a card from the current user's feed/profile listings. Idempotent.
 */
export const hideCardApiV1AuthCardsCardIdHidePost = <ThrowOnError extends boolean = true>(options: Options<HideCardApiV1AuthCardsCardIdHidePostData, ThrowOnError>): RequestResult<HideCardApiV1AuthCardsCardIdHidePostResponses, HideCardApiV1AuthCardsCardIdHidePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<HideCardApiV1AuthCardsCardIdHidePostResponses, HideCardApiV1AuthCardsCardIdHidePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zHideCardApiV1AuthCardsCardIdHidePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/cards/{card_id}/hide',
    ...options
});

/**
 * Report Card
 *
 * Hide card for current user and register a content report. Idempotent.
 */
export const reportCardApiV1AuthCardsCardIdReportPost = <ThrowOnError extends boolean = true>(options: Options<ReportCardApiV1AuthCardsCardIdReportPostData, ThrowOnError>): RequestResult<ReportCardApiV1AuthCardsCardIdReportPostResponses, ReportCardApiV1AuthCardsCardIdReportPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<ReportCardApiV1AuthCardsCardIdReportPostResponses, ReportCardApiV1AuthCardsCardIdReportPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zReportCardApiV1AuthCardsCardIdReportPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/cards/{card_id}/report',
    ...options
});

/**
 * Get Avatars
 *
 * Get list of all available avatars for user selection.
 *
 * This endpoint returns two lists:
 * - **stock**: All available stock avatars (always available, no authentication required)
 * - **custom**: User's uploaded custom avatars (only returned if user is authenticated)
 *
 * Each avatar contains:
 * - `id`: Avatar identifier (use this when setting avatar via `/update_user`)
 * - `type`: Avatar type ("stock" or "custom")
 * - `url`: Avatar image URL (large size)
 *
 * **Usage:**
 * - Display all stock avatars in avatar selection UI
 * - Show user's custom avatars if they have uploaded any
 * - Use `id` field to set avatar: `POST /update_user` with `{"avatar_id": "a-1"}`
 *
 * **Response structure:**
 * ```json
 * {
 * "stock": [
 * {"id": "a-1", "type": "stock", "url": "https://..."},
 * {"id": "a-2", "type": "stock", "url": "https://..."}
 * ],
 * "custom": [
 * {"id": "123", "type": "custom", "url": "https://..."}
 * ]
 * }
 * ```
 */
export const getAvatarsApiV1AuthAvatarsGet = <ThrowOnError extends boolean = true>(options?: Options<GetAvatarsApiV1AuthAvatarsGetData, ThrowOnError>): RequestResult<GetAvatarsApiV1AuthAvatarsGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetAvatarsApiV1AuthAvatarsGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetAvatarsApiV1AuthAvatarsGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/avatars',
    ...options
});

/**
 * Get VPN key for profile popup
 *
 * Return VLESS key and notification_id for the Luni VPN profile popup.
 */
export const getUserVpnKeyApiV1AuthUserUserIdVpnKeyGet = <ThrowOnError extends boolean = true>(options: Options<GetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetData, ThrowOnError>): RequestResult<GetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetResponses, GetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetResponses, GetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserVpnKeyApiV1AuthUserUserIdVpnKeyGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/vpn-key',
    ...options
});

/**
 * Get Feed
 *
 * Public card feed (newest first). Without cursor marks feed as seen.
 */
export const getFeedApiV1AuthFeedGet = <ThrowOnError extends boolean = true>(options?: Options<GetFeedApiV1AuthFeedGetData, ThrowOnError>): RequestResult<GetFeedApiV1AuthFeedGetResponses, GetFeedApiV1AuthFeedGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetFeedApiV1AuthFeedGetResponses, GetFeedApiV1AuthFeedGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetFeedApiV1AuthFeedGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/feed',
    ...options
});

/**
 * Get Feed Status
 *
 * Whether there are new feed cards since last visit (tab bar badge).
 */
export const getFeedStatusApiV1AuthFeedStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetFeedStatusApiV1AuthFeedStatusGetData, ThrowOnError>): RequestResult<GetFeedStatusApiV1AuthFeedStatusGetResponses, GetFeedStatusApiV1AuthFeedStatusGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetFeedStatusApiV1AuthFeedStatusGetResponses, GetFeedStatusApiV1AuthFeedStatusGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetFeedStatusApiV1AuthFeedStatusGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/feed/status',
    ...options
});

/**
 * Get Qotd Current
 *
 * Today's Question of the Day and whether the viewer may read the feed.
 */
export const getQotdCurrentApiV1AuthFeedQotdCurrentGet = <ThrowOnError extends boolean = true>(options?: Options<GetQotdCurrentApiV1AuthFeedQotdCurrentGetData, ThrowOnError>): RequestResult<GetQotdCurrentApiV1AuthFeedQotdCurrentGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetQotdCurrentApiV1AuthFeedQotdCurrentGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetQotdCurrentApiV1AuthFeedQotdCurrentGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/feed/qotd/current',
    ...options
});

/**
 * Post Qotd Answer
 *
 * Submit answer to today's Question of the Day.
 */
export const postQotdAnswerApiV1AuthFeedQotdAnswerPost = <ThrowOnError extends boolean = true>(options: Options<PostQotdAnswerApiV1AuthFeedQotdAnswerPostData, ThrowOnError>): RequestResult<PostQotdAnswerApiV1AuthFeedQotdAnswerPostResponses, PostQotdAnswerApiV1AuthFeedQotdAnswerPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<PostQotdAnswerApiV1AuthFeedQotdAnswerPostResponses, PostQotdAnswerApiV1AuthFeedQotdAnswerPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zPostQotdAnswerApiV1AuthFeedQotdAnswerPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/feed/qotd/answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get personality profile by user id
 *
 * Returns `personality_profile: null` if not generated yet. Own id: full `personality`. Other user: **404** if user missing; sections with `visibility.* = false` appear as **null** inside `personality` (snake_case keys, e.g. `big_five`, `x_axis`).
 */
export const getUserPersonalityApiV1AuthUserUserIdPersonalityGet = <ThrowOnError extends boolean = true>(options: Options<GetUserPersonalityApiV1AuthUserUserIdPersonalityGetData, ThrowOnError>): RequestResult<GetUserPersonalityApiV1AuthUserUserIdPersonalityGetResponses, GetUserPersonalityApiV1AuthUserUserIdPersonalityGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetUserPersonalityApiV1AuthUserUserIdPersonalityGetResponses, GetUserPersonalityApiV1AuthUserUserIdPersonalityGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserPersonalityApiV1AuthUserUserIdPersonalityGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/personality',
    ...options
});

/**
 * Get personality profile of another user
 *
 * Alias of **GET /user/{user_id}/personality** for another user's id.
 */
export const getFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGet = <ThrowOnError extends boolean = true>(options: Options<GetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetData, ThrowOnError>): RequestResult<GetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetResponses, GetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetResponses, GetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/friends/{friend_id}/personality',
    ...options
});

/**
 * Update which sections other users may see
 *
 * Path **user_id** must equal the authenticated user. Body: only include visibility keys you want to change. **404** if this user has no profile row yet.
 */
export const patchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatch = <ThrowOnError extends boolean = true>(options: Options<PatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchData, ThrowOnError>): RequestResult<PatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchResponses, PatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<PatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchResponses, PatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zPatchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatchResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/personality/visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate presigned URL for personality image upload
 *
 * Path **user_id** must equal the authenticated user. Returns a presigned `PUT` URL and the final public URL of the uploaded image.
 */
export const createPersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPost = <ThrowOnError extends boolean = true>(options: Options<CreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostData, ThrowOnError>): RequestResult<CreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostResponses, CreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostResponses, CreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreatePersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/personality/images/presign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * EI profile card
 */
export const getUserEiApiV1AuthUserUserIdEiGet = <ThrowOnError extends boolean = true>(options: Options<GetUserEiApiV1AuthUserUserIdEiGetData, ThrowOnError>): RequestResult<GetUserEiApiV1AuthUserUserIdEiGetResponses, GetUserEiApiV1AuthUserUserIdEiGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetUserEiApiV1AuthUserUserIdEiGetResponses, GetUserEiApiV1AuthUserUserIdEiGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserEiApiV1AuthUserUserIdEiGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/ei',
    ...options
});

/**
 * Toggle EI visibility for others
 *
 * Path user_id must equal the authenticated user. Requires a completed EI result. When visible_to_others is true, friends see the profile EI section (not full results).
 */
export const patchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatch = <ThrowOnError extends boolean = true>(options: Options<PatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchData, ThrowOnError>): RequestResult<PatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchResponses, PatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<PatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchResponses, PatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zPatchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatchResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/user/{user_id}/ei/visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start or restart EI test
 */
export const startEiTestApiV1AuthEiTestStartPost = <ThrowOnError extends boolean = true>(options: Options<StartEiTestApiV1AuthEiTestStartPostData, ThrowOnError>): RequestResult<StartEiTestApiV1AuthEiTestStartPostResponses, StartEiTestApiV1AuthEiTestStartPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<StartEiTestApiV1AuthEiTestStartPostResponses, StartEiTestApiV1AuthEiTestStartPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zStartEiTestApiV1AuthEiTestStartPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/ei/test/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get current EI test session
 */
export const getEiTestApiV1AuthEiTestGet = <ThrowOnError extends boolean = true>(options?: Options<GetEiTestApiV1AuthEiTestGetData, ThrowOnError>): RequestResult<GetEiTestApiV1AuthEiTestGetResponses, GetEiTestApiV1AuthEiTestGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetEiTestApiV1AuthEiTestGetResponses, GetEiTestApiV1AuthEiTestGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetEiTestApiV1AuthEiTestGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/ei/test',
    ...options
});

/**
 * Save answers for one EI screen
 */
export const saveEiAnswersApiV1AuthEiTestAnswersPut = <ThrowOnError extends boolean = true>(options: Options<SaveEiAnswersApiV1AuthEiTestAnswersPutData, ThrowOnError>): RequestResult<SaveEiAnswersApiV1AuthEiTestAnswersPutResponses, SaveEiAnswersApiV1AuthEiTestAnswersPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<SaveEiAnswersApiV1AuthEiTestAnswersPutResponses, SaveEiAnswersApiV1AuthEiTestAnswersPutErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSaveEiAnswersApiV1AuthEiTestAnswersPutResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/ei/test/answers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit EI test to Way2Wei and get results
 */
export const completeEiTestApiV1AuthEiTestCompletePost = <ThrowOnError extends boolean = true>(options?: Options<CompleteEiTestApiV1AuthEiTestCompletePostData, ThrowOnError>): RequestResult<CompleteEiTestApiV1AuthEiTestCompletePostResponses, CompleteEiTestApiV1AuthEiTestCompletePostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<CompleteEiTestApiV1AuthEiTestCompletePostResponses, CompleteEiTestApiV1AuthEiTestCompletePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCompleteEiTestApiV1AuthEiTestCompletePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/ei/test/complete',
    ...options
});

/**
 * Full EI results report
 */
export const getEiResultsApiV1AuthEiResultsGet = <ThrowOnError extends boolean = true>(options?: Options<GetEiResultsApiV1AuthEiResultsGetData, ThrowOnError>): RequestResult<GetEiResultsApiV1AuthEiResultsGetResponses, GetEiResultsApiV1AuthEiResultsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetEiResultsApiV1AuthEiResultsGetResponses, GetEiResultsApiV1AuthEiResultsGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetEiResultsApiV1AuthEiResultsGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/ei/results',
    ...options
});

/**
 * EI leaderboard top-19 + sticky highlight
 */
export const getEiLeaderboardApiV1AuthEiLeaderboardGet = <ThrowOnError extends boolean = true>(options?: Options<GetEiLeaderboardApiV1AuthEiLeaderboardGetData, ThrowOnError>): RequestResult<GetEiLeaderboardApiV1AuthEiLeaderboardGetResponses, GetEiLeaderboardApiV1AuthEiLeaderboardGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetEiLeaderboardApiV1AuthEiLeaderboardGetResponses, GetEiLeaderboardApiV1AuthEiLeaderboardGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetEiLeaderboardApiV1AuthEiLeaderboardGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/ei/leaderboard',
    ...options
});

/**
 * Health Check
 *
 * Health check endpoint.
 */
export const healthCheckApiV1LuniHealthGet = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckApiV1LuniHealthGetData, ThrowOnError>): RequestResult<HealthCheckApiV1LuniHealthGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<HealthCheckApiV1LuniHealthGetResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/health',
    ...options
});

/**
 * Luni Message Exchange
 *
 * Process chat message exchange with Luni.
 */
export const luniMessageExchangeApiV1LuniLuniMessageExchangePost = <ThrowOnError extends boolean = true>(options: Options<LuniMessageExchangeApiV1LuniLuniMessageExchangePostData, ThrowOnError>): RequestResult<LuniMessageExchangeApiV1LuniLuniMessageExchangePostResponses, LuniMessageExchangeApiV1LuniLuniMessageExchangePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LuniMessageExchangeApiV1LuniLuniMessageExchangePostResponses, LuniMessageExchangeApiV1LuniLuniMessageExchangePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLuniMessageExchangeApiV1LuniLuniMessageExchangePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/luni_message_exchange',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream Chat
 *
 * Stream chat response from Luni using text protocol.
 */
export const streamChatApiV1LuniStreamChatPost = <ThrowOnError extends boolean = true>(options: Options<StreamChatApiV1LuniStreamChatPostData, ThrowOnError>): RequestResult<StreamChatApiV1LuniStreamChatPostResponses, StreamChatApiV1LuniStreamChatPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<StreamChatApiV1LuniStreamChatPostResponses, StreamChatApiV1LuniStreamChatPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/stream_chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Analyze Accentuation
 *
 * Analyze user accentuation.
 */
export const analyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPost = <ThrowOnError extends boolean = true>(options: Options<AnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostData, ThrowOnError>): RequestResult<AnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostResponses, AnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostResponses, AnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zAnalyzeAccentuationApiV1LuniAnalyzeAccentuationUserIdPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/analyze_accentuation/{user_id}',
    ...options
});

/**
 * Get Validation Question
 *
 * Get validation question for user.
 */
export const getValidationQuestionApiV1LuniValidationQuestionUserIdGet = <ThrowOnError extends boolean = true>(options: Options<GetValidationQuestionApiV1LuniValidationQuestionUserIdGetData, ThrowOnError>): RequestResult<GetValidationQuestionApiV1LuniValidationQuestionUserIdGetResponses, GetValidationQuestionApiV1LuniValidationQuestionUserIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetValidationQuestionApiV1LuniValidationQuestionUserIdGetResponses, GetValidationQuestionApiV1LuniValidationQuestionUserIdGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetValidationQuestionApiV1LuniValidationQuestionUserIdGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/validation_question/{user_id}',
    ...options
});

/**
 * Validate Pending Replies
 *
 * Validate all pending replies.
 */
export const validatePendingRepliesApiV1LuniValidatePendingRepliesPost = <ThrowOnError extends boolean = true>(options?: Options<ValidatePendingRepliesApiV1LuniValidatePendingRepliesPostData, ThrowOnError>): RequestResult<ValidatePendingRepliesApiV1LuniValidatePendingRepliesPostResponses, ValidatePendingRepliesApiV1LuniValidatePendingRepliesPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<ValidatePendingRepliesApiV1LuniValidatePendingRepliesPostResponses, ValidatePendingRepliesApiV1LuniValidatePendingRepliesPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zValidatePendingRepliesApiV1LuniValidatePendingRepliesPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/validate_pending_replies',
    ...options
});

/**
 * Get Last Message
 *
 * Get last message from Luni.
 *
 * Returns the most recent message from Luni without reversing order,
 * ensuring the actual last message is returned when user reopens chat.
 */
export const getLastMessageApiV1LuniLuniGetLastMessageGet = <ThrowOnError extends boolean = true>(options: Options<GetLastMessageApiV1LuniLuniGetLastMessageGetData, ThrowOnError>): RequestResult<GetLastMessageApiV1LuniLuniGetLastMessageGetResponses, GetLastMessageApiV1LuniLuniGetLastMessageGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetLastMessageApiV1LuniLuniGetLastMessageGetResponses, GetLastMessageApiV1LuniLuniGetLastMessageGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetLastMessageApiV1LuniLuniGetLastMessageGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/luni_get_last_message',
    ...options
});

/**
 * Debug Messages
 *
 * Debug: Get message history for user.
 */
export const debugMessagesApiV1LuniDebugMessagesUserIdGet = <ThrowOnError extends boolean = true>(options: Options<DebugMessagesApiV1LuniDebugMessagesUserIdGetData, ThrowOnError>): RequestResult<DebugMessagesApiV1LuniDebugMessagesUserIdGetResponses, DebugMessagesApiV1LuniDebugMessagesUserIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DebugMessagesApiV1LuniDebugMessagesUserIdGetResponses, DebugMessagesApiV1LuniDebugMessagesUserIdGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/debug/messages/{user_id}',
    ...options
});

/**
 * Debug Accentuations Validation Question
 *
 * Debug: Get accentuation validation question.
 */
export const debugAccentuationsValidationQuestionApiV1LuniDebugAccentuationsValidationQuestionUserIdGet = <ThrowOnError extends boolean = true>(options: Options<DebugAccentuationsValidationQuestionApiV1LuniDebugAccentuationsValidationQuestionUserIdGetData, ThrowOnError>): RequestResult<DebugAccentuationsValidationQuestionApiV1LuniDebugAccentuationsValidationQuestionUserIdGetResponses, DebugAccentuationsValidationQuestionApiV1LuniDebugAccentuationsValidationQuestionUserIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DebugAccentuationsValidationQuestionApiV1LuniDebugAccentuationsValidationQuestionUserIdGetResponses, DebugAccentuationsValidationQuestionApiV1LuniDebugAccentuationsValidationQuestionUserIdGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/debug/accentuations_validation_question/{user_id}',
    ...options
});

/**
 * Debug Process Validation Reply
 *
 * Debug: Process validation replies.
 */
export const debugProcessValidationReplyApiV1LuniDebugProcessValidationReplyPost = <ThrowOnError extends boolean = true>(options?: Options<DebugProcessValidationReplyApiV1LuniDebugProcessValidationReplyPostData, ThrowOnError>): RequestResult<DebugProcessValidationReplyApiV1LuniDebugProcessValidationReplyPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<DebugProcessValidationReplyApiV1LuniDebugProcessValidationReplyPostResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/luni/debug/process_validation_reply',
    ...options
});

/**
 * Character Send Message
 *
 * Synchronous persona reply.
 */
export const characterSendMessageApiV1CharacterCharacterSendMessagePost = <ThrowOnError extends boolean = true>(options: Options<CharacterSendMessageApiV1CharacterCharacterSendMessagePostData, ThrowOnError>): RequestResult<CharacterSendMessageApiV1CharacterCharacterSendMessagePostResponses, CharacterSendMessageApiV1CharacterCharacterSendMessagePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CharacterSendMessageApiV1CharacterCharacterSendMessagePostResponses, CharacterSendMessageApiV1CharacterCharacterSendMessagePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCharacterSendMessageApiV1CharacterCharacterSendMessagePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/character/{character}/send_message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Character Stream
 *
 * Plain-text stream (same wire format as legacy ``/luni/stream_chat``).
 */
export const characterStreamApiV1CharacterCharacterStreamPost = <ThrowOnError extends boolean = true>(options: Options<CharacterStreamApiV1CharacterCharacterStreamPostData, ThrowOnError>): RequestResult<CharacterStreamApiV1CharacterCharacterStreamPostResponses, CharacterStreamApiV1CharacterCharacterStreamPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CharacterStreamApiV1CharacterCharacterStreamPostResponses, CharacterStreamApiV1CharacterCharacterStreamPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCharacterStreamApiV1CharacterCharacterStreamPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/character/{character}/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Character Last Message
 *
 * Last assistant line for the given persona (for home card).
 */
export const characterLastMessageApiV1CharacterCharacterLastMessageGet = <ThrowOnError extends boolean = true>(options: Options<CharacterLastMessageApiV1CharacterCharacterLastMessageGetData, ThrowOnError>): RequestResult<CharacterLastMessageApiV1CharacterCharacterLastMessageGetResponses, CharacterLastMessageApiV1CharacterCharacterLastMessageGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<CharacterLastMessageApiV1CharacterCharacterLastMessageGetResponses, CharacterLastMessageApiV1CharacterCharacterLastMessageGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCharacterLastMessageApiV1CharacterCharacterLastMessageGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/character/{character}/last_message',
    ...options
});

/**
 * Send support message to Telegram team chat
 *
 * Send support message to Telegram team chat.
 *
 * Args:
 * request: Support message request.
 * support_service: Support service instance.
 *
 * Returns:
 * SupportMessageResponse: Response with status and message.
 *
 * Raises:
 * HTTPException: If configuration is missing or service fails.
 */
export const sendSupportMessageApiV1SupportSendPost = <ThrowOnError extends boolean = true>(options: Options<SendSupportMessageApiV1SupportSendPostData, ThrowOnError>): RequestResult<SendSupportMessageApiV1SupportSendPostResponses, SendSupportMessageApiV1SupportSendPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SendSupportMessageApiV1SupportSendPostResponses, SendSupportMessageApiV1SupportSendPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSendSupportMessageApiV1SupportSendPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/support/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Thoughts
 *
 * Get user's thoughts (authenticated endpoint).
 */
export const getUserThoughtsApiV1UsersGet = <ThrowOnError extends boolean = true>(options?: Options<GetUserThoughtsApiV1UsersGetData, ThrowOnError>): RequestResult<GetUserThoughtsApiV1UsersGetResponses, GetUserThoughtsApiV1UsersGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetUserThoughtsApiV1UsersGetResponses, GetUserThoughtsApiV1UsersGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserThoughtsApiV1UsersGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/',
    ...options
});

/**
 * Create Thought
 *
 * Create new thought entry.
 */
export const createThoughtApiV1UsersPost = <ThrowOnError extends boolean = true>(options: Options<CreateThoughtApiV1UsersPostData, ThrowOnError>): RequestResult<CreateThoughtApiV1UsersPostResponses, CreateThoughtApiV1UsersPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CreateThoughtApiV1UsersPostResponses, CreateThoughtApiV1UsersPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateThoughtApiV1UsersPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Thought By User Id
 *
 * Delete thought entry for specific user.
 */
export const deleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteData, ThrowOnError>): RequestResult<DeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteResponses, DeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteResponses, DeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDeleteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/thoughts/{thought_id}',
    ...options
});

/**
 * Get User Thought By User And Id
 *
 * Get specific thought by user and thought id.
 */
export const getUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGet = <ThrowOnError extends boolean = true>(options: Options<GetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetData, ThrowOnError>): RequestResult<GetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetResponses, GetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetResponses, GetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/thoughts/{thought_id}',
    ...options
});

/**
 * Update Thought By User Id
 *
 * Update thought entry for specific user.
 */
export const updateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPut = <ThrowOnError extends boolean = true>(options: Options<UpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutData, ThrowOnError>): RequestResult<UpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutResponses, UpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<UpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutResponses, UpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPutResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/thoughts/{thought_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Thoughts By Id
 *
 * Get user's thoughts by user ID.
 */
export const getUserThoughtsByIdApiV1UsersUserIdThoughtsGet = <ThrowOnError extends boolean = true>(options: Options<GetUserThoughtsByIdApiV1UsersUserIdThoughtsGetData, ThrowOnError>): RequestResult<GetUserThoughtsByIdApiV1UsersUserIdThoughtsGetResponses, GetUserThoughtsByIdApiV1UsersUserIdThoughtsGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetUserThoughtsByIdApiV1UsersUserIdThoughtsGetResponses, GetUserThoughtsByIdApiV1UsersUserIdThoughtsGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserThoughtsByIdApiV1UsersUserIdThoughtsGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/thoughts',
    ...options
});

/**
 * Create Thought By User Id
 *
 * Create new thought entry for specific user.
 */
export const createThoughtByUserIdApiV1UsersUserIdThoughtsPost = <ThrowOnError extends boolean = true>(options: Options<CreateThoughtByUserIdApiV1UsersUserIdThoughtsPostData, ThrowOnError>): RequestResult<CreateThoughtByUserIdApiV1UsersUserIdThoughtsPostResponses, CreateThoughtByUserIdApiV1UsersUserIdThoughtsPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CreateThoughtByUserIdApiV1UsersUserIdThoughtsPostResponses, CreateThoughtByUserIdApiV1UsersUserIdThoughtsPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateThoughtByUserIdApiV1UsersUserIdThoughtsPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/thoughts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Thought
 *
 * Delete thought.
 */
export const deleteThoughtApiV1UsersThoughtIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteThoughtApiV1UsersThoughtIdDeleteData, ThrowOnError>): RequestResult<DeleteThoughtApiV1UsersThoughtIdDeleteResponses, DeleteThoughtApiV1UsersThoughtIdDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DeleteThoughtApiV1UsersThoughtIdDeleteResponses, DeleteThoughtApiV1UsersThoughtIdDeleteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteThoughtApiV1UsersThoughtIdDeleteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{thought_id}',
    ...options
});

/**
 * Get Thought
 *
 * Get thought by ID.
 */
export const getThoughtApiV1UsersThoughtIdGet = <ThrowOnError extends boolean = true>(options: Options<GetThoughtApiV1UsersThoughtIdGetData, ThrowOnError>): RequestResult<GetThoughtApiV1UsersThoughtIdGetResponses, GetThoughtApiV1UsersThoughtIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetThoughtApiV1UsersThoughtIdGetResponses, GetThoughtApiV1UsersThoughtIdGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetThoughtApiV1UsersThoughtIdGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{thought_id}',
    ...options
});

/**
 * Update Thought
 *
 * Update thought.
 */
export const updateThoughtApiV1UsersThoughtIdPut = <ThrowOnError extends boolean = true>(options: Options<UpdateThoughtApiV1UsersThoughtIdPutData, ThrowOnError>): RequestResult<UpdateThoughtApiV1UsersThoughtIdPutResponses, UpdateThoughtApiV1UsersThoughtIdPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<UpdateThoughtApiV1UsersThoughtIdPutResponses, UpdateThoughtApiV1UsersThoughtIdPutErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateThoughtApiV1UsersThoughtIdPutResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{thought_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Thoughts By Date
 *
 * Get thoughts by calendar date in the user's timezone.
 */
export const getThoughtsByDateApiV1UsersDateThoughtsDateGet = <ThrowOnError extends boolean = true>(options: Options<GetThoughtsByDateApiV1UsersDateThoughtsDateGetData, ThrowOnError>): RequestResult<GetThoughtsByDateApiV1UsersDateThoughtsDateGetResponses, GetThoughtsByDateApiV1UsersDateThoughtsDateGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetThoughtsByDateApiV1UsersDateThoughtsDateGetResponses, GetThoughtsByDateApiV1UsersDateThoughtsDateGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetThoughtsByDateApiV1UsersDateThoughtsDateGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/date/{thoughts_date}',
    ...options
});

/**
 * Mark Thought As Read
 *
 * Mark thought as read.
 */
export const markThoughtAsReadApiV1UsersThoughtIdReadPatch = <ThrowOnError extends boolean = true>(options: Options<MarkThoughtAsReadApiV1UsersThoughtIdReadPatchData, ThrowOnError>): RequestResult<MarkThoughtAsReadApiV1UsersThoughtIdReadPatchResponses, MarkThoughtAsReadApiV1UsersThoughtIdReadPatchErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<MarkThoughtAsReadApiV1UsersThoughtIdReadPatchResponses, MarkThoughtAsReadApiV1UsersThoughtIdReadPatchErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zMarkThoughtAsReadApiV1UsersThoughtIdReadPatchResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{thought_id}/read',
    ...options
});

/**
 * Mark Thought As Read Alias
 *
 * Alias: Mark thought as read using user_id in path (luni compatibility).
 */
export const markThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPost = <ThrowOnError extends boolean = true>(options: Options<MarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostData, ThrowOnError>): RequestResult<MarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostResponses, MarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<MarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostResponses, MarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zMarkThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/thoughts/{thought_id}/mark-read',
    ...options
});

/**
 * Get Ai Generated Thoughts
 *
 * Get AI generated thoughts for user.
 */
export const getAiGeneratedThoughtsApiV1UsersAiGeneratedGet = <ThrowOnError extends boolean = true>(options?: Options<GetAiGeneratedThoughtsApiV1UsersAiGeneratedGetData, ThrowOnError>): RequestResult<GetAiGeneratedThoughtsApiV1UsersAiGeneratedGetResponses, GetAiGeneratedThoughtsApiV1UsersAiGeneratedGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetAiGeneratedThoughtsApiV1UsersAiGeneratedGetResponses, GetAiGeneratedThoughtsApiV1UsersAiGeneratedGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetAiGeneratedThoughtsApiV1UsersAiGeneratedGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/ai/generated',
    ...options
});

/**
 * Get Dot Plot Meta
 *
 * Cheap snapshot metadata for the admin matrix.
 */
export const getDotPlotMetaApiV1AnalyticsAdminDotPlotMetaGet = <ThrowOnError extends boolean = true>(options?: Options<GetDotPlotMetaApiV1AnalyticsAdminDotPlotMetaGetData, ThrowOnError>): RequestResult<GetDotPlotMetaApiV1AnalyticsAdminDotPlotMetaGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetDotPlotMetaApiV1AnalyticsAdminDotPlotMetaGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetDotPlotMetaApiV1AnalyticsAdminDotPlotMetaGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/admin/dot-plot/meta',
    ...options
});

/**
 * Get Dot Plot
 *
 * Chunk of the activity matrix from precomputed snapshot tables.
 */
export const getDotPlotApiV1AnalyticsAdminDotPlotGet = <ThrowOnError extends boolean = true>(options?: Options<GetDotPlotApiV1AnalyticsAdminDotPlotGetData, ThrowOnError>): RequestResult<GetDotPlotApiV1AnalyticsAdminDotPlotGetResponses, GetDotPlotApiV1AnalyticsAdminDotPlotGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetDotPlotApiV1AnalyticsAdminDotPlotGetResponses, GetDotPlotApiV1AnalyticsAdminDotPlotGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetDotPlotApiV1AnalyticsAdminDotPlotGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/admin/dot-plot',
    ...options
});

/**
 * Rebuild Dot Plot
 *
 * Ops-only snapshot rebuild. Not used on page load.
 */
export const rebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPost = <ThrowOnError extends boolean = true>(options?: Options<RebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostData, ThrowOnError>): RequestResult<RebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostResponses, RebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<RebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostResponses, RebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRebuildDotPlotApiV1AnalyticsAdminDotPlotRebuildPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/admin/dot-plot/rebuild',
    ...options
});

/**
 * Get Push Tracking Meta
 *
 * Cheap snapshot metadata for the admin push matrix.
 */
export const getPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGet = <ThrowOnError extends boolean = true>(options?: Options<GetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetData, ThrowOnError>): RequestResult<GetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetResponses, GetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetResponses, GetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetPushTrackingMetaApiV1AnalyticsAdminPushTrackingMetaGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/admin/push-tracking/meta',
    ...options
});

/**
 * Get Push Tracking
 *
 * Full push-template matrix from precomputed snapshot tables.
 */
export const getPushTrackingApiV1AnalyticsAdminPushTrackingGet = <ThrowOnError extends boolean = true>(options?: Options<GetPushTrackingApiV1AnalyticsAdminPushTrackingGetData, ThrowOnError>): RequestResult<GetPushTrackingApiV1AnalyticsAdminPushTrackingGetResponses, GetPushTrackingApiV1AnalyticsAdminPushTrackingGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GetPushTrackingApiV1AnalyticsAdminPushTrackingGetResponses, GetPushTrackingApiV1AnalyticsAdminPushTrackingGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetPushTrackingApiV1AnalyticsAdminPushTrackingGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/admin/push-tracking',
    ...options
});

/**
 * Rebuild Push Tracking
 *
 * Ops-only snapshot rebuild. Not used on page load.
 */
export const rebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPost = <ThrowOnError extends boolean = true>(options?: Options<RebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostData, ThrowOnError>): RequestResult<RebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostResponses, RebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<RebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostResponses, RebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRebuildPushTrackingApiV1AnalyticsAdminPushTrackingRebuildPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/admin/push-tracking/rebuild',
    ...options
});

/**
 * Record App Page Visit
 *
 * Client ping: app is in the foreground. Idempotent per UTC day.
 */
export const recordAppPageVisitApiV1AnalyticsPageVisitsAppPost = <ThrowOnError extends boolean = true>(options?: Options<RecordAppPageVisitApiV1AnalyticsPageVisitsAppPostData, ThrowOnError>): RequestResult<RecordAppPageVisitApiV1AnalyticsPageVisitsAppPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<RecordAppPageVisitApiV1AnalyticsPageVisitsAppPostResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRecordAppPageVisitApiV1AnalyticsPageVisitsAppPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/page-visits/app',
    ...options
});

/**
 * Record Diary Page Visit
 *
 * Client ping: user opened the diary screen. Idempotent per UTC day.
 */
export const recordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPost = <ThrowOnError extends boolean = true>(options?: Options<RecordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPostData, ThrowOnError>): RequestResult<RecordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<RecordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPostResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRecordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/page-visits/diary',
    ...options
});

/**
 * Record Feed Page Visit
 *
 * Client ping: user opened the feed screen. Idempotent per UTC day.
 */
export const recordFeedPageVisitApiV1AnalyticsPageVisitsFeedPost = <ThrowOnError extends boolean = true>(options?: Options<RecordFeedPageVisitApiV1AnalyticsPageVisitsFeedPostData, ThrowOnError>): RequestResult<RecordFeedPageVisitApiV1AnalyticsPageVisitsFeedPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<RecordFeedPageVisitApiV1AnalyticsPageVisitsFeedPostResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRecordFeedPageVisitApiV1AnalyticsPageVisitsFeedPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/page-visits/feed',
    ...options
});

/**
 * Get User Analytics
 *
 * Get user analytics.
 */
export const getUserAnalyticsApiV1AnalyticsUsersGet = <ThrowOnError extends boolean = true>(options?: Options<GetUserAnalyticsApiV1AnalyticsUsersGetData, ThrowOnError>): RequestResult<GetUserAnalyticsApiV1AnalyticsUsersGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetUserAnalyticsApiV1AnalyticsUsersGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserAnalyticsApiV1AnalyticsUsersGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/users',
    ...options
});

/**
 * Get Friendship Analytics
 *
 * Get friendship analytics.
 */
export const getFriendshipAnalyticsApiV1AnalyticsFriendshipsGet = <ThrowOnError extends boolean = true>(options?: Options<GetFriendshipAnalyticsApiV1AnalyticsFriendshipsGetData, ThrowOnError>): RequestResult<GetFriendshipAnalyticsApiV1AnalyticsFriendshipsGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetFriendshipAnalyticsApiV1AnalyticsFriendshipsGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetFriendshipAnalyticsApiV1AnalyticsFriendshipsGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/friendships',
    ...options
});

/**
 * Get Luni Analytics
 *
 * Get Luni chat analytics.
 */
export const getLuniAnalyticsApiV1AnalyticsLuniGet = <ThrowOnError extends boolean = true>(options?: Options<GetLuniAnalyticsApiV1AnalyticsLuniGetData, ThrowOnError>): RequestResult<GetLuniAnalyticsApiV1AnalyticsLuniGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetLuniAnalyticsApiV1AnalyticsLuniGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetLuniAnalyticsApiV1AnalyticsLuniGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/luni',
    ...options
});

/**
 * Get System Metrics
 *
 * Get system metrics.
 */
export const getSystemMetricsApiV1AnalyticsSystemGet = <ThrowOnError extends boolean = true>(options?: Options<GetSystemMetricsApiV1AnalyticsSystemGetData, ThrowOnError>): RequestResult<GetSystemMetricsApiV1AnalyticsSystemGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetSystemMetricsApiV1AnalyticsSystemGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetSystemMetricsApiV1AnalyticsSystemGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/system',
    ...options
});

/**
 * Get Pending Requests Analytics
 *
 * Get analytics for pending friendship requests.
 */
export const getPendingRequestsAnalyticsApiV1AnalyticsPendingRequestsGet = <ThrowOnError extends boolean = true>(options?: Options<GetPendingRequestsAnalyticsApiV1AnalyticsPendingRequestsGetData, ThrowOnError>): RequestResult<GetPendingRequestsAnalyticsApiV1AnalyticsPendingRequestsGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetPendingRequestsAnalyticsApiV1AnalyticsPendingRequestsGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetPendingRequestsAnalyticsApiV1AnalyticsPendingRequestsGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/pending-requests',
    ...options
});

/**
 * Get Analytics Overview
 *
 * Get comprehensive analytics overview.
 */
export const getAnalyticsOverviewApiV1AnalyticsOverviewGet = <ThrowOnError extends boolean = true>(options?: Options<GetAnalyticsOverviewApiV1AnalyticsOverviewGetData, ThrowOnError>): RequestResult<GetAnalyticsOverviewApiV1AnalyticsOverviewGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetAnalyticsOverviewApiV1AnalyticsOverviewGetResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/overview',
    ...options
});

/**
 * Get Rank Stats
 *
 * Synthetic population counts for top activity ranks.
 */
export const getRankStatsApiV1RanksStatsGet = <ThrowOnError extends boolean = true>(options?: Options<GetRankStatsApiV1RanksStatsGetData, ThrowOnError>): RequestResult<GetRankStatsApiV1RanksStatsGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<GetRankStatsApiV1RanksStatsGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetRankStatsApiV1RanksStatsGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ranks/stats',
    ...options
});

/**
 * Record Google Play install referrer (pre-registration)
 *
 * Store install referrer keyed by device_id before user registers.
 */
export const postAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPost = <ThrowOnError extends boolean = true>(options: Options<PostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostData, ThrowOnError>): RequestResult<PostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostResponses, PostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<PostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostResponses, PostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zPostAndroidInstallReferrerApiV1AttributionAndroidInstallReferrerPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/attribution/android-install-referrer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save pre-registration onboarding intention
 *
 * Public endpoint: store intention before user registration.
 */
export const saveOnboardingIntentionApiV1OnboardingIntentionPost = <ThrowOnError extends boolean = true>(options: Options<SaveOnboardingIntentionApiV1OnboardingIntentionPostData, ThrowOnError>): RequestResult<SaveOnboardingIntentionApiV1OnboardingIntentionPostResponses, SaveOnboardingIntentionApiV1OnboardingIntentionPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SaveOnboardingIntentionApiV1OnboardingIntentionPostResponses, SaveOnboardingIntentionApiV1OnboardingIntentionPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSaveOnboardingIntentionApiV1OnboardingIntentionPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/onboarding/intention',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save pre-registration VPN interest answer
 *
 * Public endpoint: store VPN interest answer before user registration.
 */
export const saveOnboardingVpnApiV1OnboardingVpnPost = <ThrowOnError extends boolean = true>(options: Options<SaveOnboardingVpnApiV1OnboardingVpnPostData, ThrowOnError>): RequestResult<SaveOnboardingVpnApiV1OnboardingVpnPostResponses, SaveOnboardingVpnApiV1OnboardingVpnPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SaveOnboardingVpnApiV1OnboardingVpnPostResponses, SaveOnboardingVpnApiV1OnboardingVpnPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSaveOnboardingVpnApiV1OnboardingVpnPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/onboarding/vpn',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save pre-registration answer: how did you hear about Luni
 *
 * Public endpoint: store free-text source before user registration.
 */
export const saveOnboardingHeardAboutApiV1OnboardingHeardAboutPost = <ThrowOnError extends boolean = true>(options: Options<SaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostData, ThrowOnError>): RequestResult<SaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostResponses, SaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostResponses, SaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSaveOnboardingHeardAboutApiV1OnboardingHeardAboutPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/onboarding/heard-about',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save pre-registration Instagram username
 *
 * Public endpoint: stash Instagram by X-Device-Id for later register glue.
 *
 * Missing X-Device-Id is not an error — returns 200 without storing.
 */
export const saveOnboardingInstagramApiV1OnboardingInstagramPost = <ThrowOnError extends boolean = true>(options: Options<SaveOnboardingInstagramApiV1OnboardingInstagramPostData, ThrowOnError>): RequestResult<SaveOnboardingInstagramApiV1OnboardingInstagramPostResponses, SaveOnboardingInstagramApiV1OnboardingInstagramPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SaveOnboardingInstagramApiV1OnboardingInstagramPostResponses, SaveOnboardingInstagramApiV1OnboardingInstagramPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSaveOnboardingInstagramApiV1OnboardingInstagramPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/onboarding/instagram',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Translate or transliterate a friend's texts into the target language
 */
export const translateApiV1TranslatePost = <ThrowOnError extends boolean = true>(options: Options<TranslateApiV1TranslatePostData, ThrowOnError>): RequestResult<TranslateApiV1TranslatePostResponses, TranslateApiV1TranslatePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<TranslateApiV1TranslatePostResponses, TranslateApiV1TranslatePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zTranslateApiV1TranslatePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/translate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register telegram user
 *
 * Register or update telegram user when they press /start in bot.
 *
 * Args:
 * user_data: Telegram user data.
 * telegram_service: Telegram service instance.
 *
 * Returns:
 * TelegramUserOut: Created telegram user.
 *
 * Raises:
 * HTTPException: If registration fails.
 */
export const registerTelegramUserApiV1TelegramRegisterPost = <ThrowOnError extends boolean = true>(options: Options<RegisterTelegramUserApiV1TelegramRegisterPostData, ThrowOnError>): RequestResult<RegisterTelegramUserApiV1TelegramRegisterPostResponses, RegisterTelegramUserApiV1TelegramRegisterPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<RegisterTelegramUserApiV1TelegramRegisterPostResponses, RegisterTelegramUserApiV1TelegramRegisterPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRegisterTelegramUserApiV1TelegramRegisterPostResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/telegram/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete telegram user
 *
 * Delete telegram user.
 *
 * Args:
 * telegram_id: Telegram user ID.
 * telegram_service: Telegram service instance.
 *
 * Returns:
 * dict: Success message.
 *
 * Raises:
 * HTTPException: If deletion fails.
 */
export const deleteTelegramUserEndpointApiV1TelegramTelegramIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteTelegramUserEndpointApiV1TelegramTelegramIdDeleteData, ThrowOnError>): RequestResult<DeleteTelegramUserEndpointApiV1TelegramTelegramIdDeleteResponses, DeleteTelegramUserEndpointApiV1TelegramTelegramIdDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DeleteTelegramUserEndpointApiV1TelegramTelegramIdDeleteResponses, DeleteTelegramUserEndpointApiV1TelegramTelegramIdDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/telegram/{telegram_id}',
    ...options
});

/**
 * Get telegram user
 *
 * Get telegram user by telegram_id.
 *
 * Args:
 * telegram_id: Telegram user ID.
 * telegram_service: Telegram service instance.
 *
 * Returns:
 * TelegramUserOut: Telegram user data.
 *
 * Raises:
 * HTTPException: If user not found.
 */
export const getTelegramUserEndpointApiV1TelegramTelegramIdGet = <ThrowOnError extends boolean = true>(options: Options<GetTelegramUserEndpointApiV1TelegramTelegramIdGetData, ThrowOnError>): RequestResult<GetTelegramUserEndpointApiV1TelegramTelegramIdGetResponses, GetTelegramUserEndpointApiV1TelegramTelegramIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GetTelegramUserEndpointApiV1TelegramTelegramIdGetResponses, GetTelegramUserEndpointApiV1TelegramTelegramIdGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetTelegramUserEndpointApiV1TelegramTelegramIdGetResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/telegram/{telegram_id}',
    ...options
});

/**
 * Update telegram user
 *
 * Update telegram user data.
 *
 * Args:
 * telegram_id: Telegram user ID.
 * user_data: Updated telegram user data.
 * telegram_service: Telegram service instance.
 *
 * Returns:
 * TelegramUserOut: Updated telegram user.
 *
 * Raises:
 * HTTPException: If user not found or update fails.
 */
export const updateTelegramUserEndpointApiV1TelegramTelegramIdPut = <ThrowOnError extends boolean = true>(options: Options<UpdateTelegramUserEndpointApiV1TelegramTelegramIdPutData, ThrowOnError>): RequestResult<UpdateTelegramUserEndpointApiV1TelegramTelegramIdPutResponses, UpdateTelegramUserEndpointApiV1TelegramTelegramIdPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<UpdateTelegramUserEndpointApiV1TelegramTelegramIdPutResponses, UpdateTelegramUserEndpointApiV1TelegramTelegramIdPutErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateTelegramUserEndpointApiV1TelegramTelegramIdPutResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/api/v1/telegram/{telegram_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cloudpayments Check
 *
 * Check notification: validate payment before authorization.
 */
export const cloudpaymentsCheckApiV1PaymentsCloudpaymentsCheckPost = <ThrowOnError extends boolean = true>(options?: Options<CloudpaymentsCheckApiV1PaymentsCloudpaymentsCheckPostData, ThrowOnError>): RequestResult<CloudpaymentsCheckApiV1PaymentsCloudpaymentsCheckPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<CloudpaymentsCheckApiV1PaymentsCloudpaymentsCheckPostResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/payments/cloudpayments/check',
    ...options
});

/**
 * Cloudpayments Pay
 *
 * Pay notification: payment completed. Register and return code 0.
 */
export const cloudpaymentsPayApiV1PaymentsCloudpaymentsPayPost = <ThrowOnError extends boolean = true>(options?: Options<CloudpaymentsPayApiV1PaymentsCloudpaymentsPayPostData, ThrowOnError>): RequestResult<CloudpaymentsPayApiV1PaymentsCloudpaymentsPayPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<CloudpaymentsPayApiV1PaymentsCloudpaymentsPayPostResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/payments/cloudpayments/pay',
    ...options
});

/**
 * Cloudpayments Recurrent
 *
 * Recurrent notification: subscription status changed.
 */
export const cloudpaymentsRecurrentApiV1PaymentsCloudpaymentsRecurrentPost = <ThrowOnError extends boolean = true>(options?: Options<CloudpaymentsRecurrentApiV1PaymentsCloudpaymentsRecurrentPostData, ThrowOnError>): RequestResult<CloudpaymentsRecurrentApiV1PaymentsCloudpaymentsRecurrentPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<CloudpaymentsRecurrentApiV1PaymentsCloudpaymentsRecurrentPostResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/payments/cloudpayments/recurrent',
    ...options
});

/**
 * Cloudpayments Refund
 *
 * Refund notification: refund completed.
 */
export const cloudpaymentsRefundApiV1PaymentsCloudpaymentsRefundPost = <ThrowOnError extends boolean = true>(options?: Options<CloudpaymentsRefundApiV1PaymentsCloudpaymentsRefundPostData, ThrowOnError>): RequestResult<CloudpaymentsRefundApiV1PaymentsCloudpaymentsRefundPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<CloudpaymentsRefundApiV1PaymentsCloudpaymentsRefundPostResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/payments/cloudpayments/refund',
    ...options
});

/**
 * Cloudpayments Cancel
 *
 * Cancel notification: subscription cancelled.
 */
export const cloudpaymentsCancelApiV1PaymentsCloudpaymentsCancelPost = <ThrowOnError extends boolean = true>(options?: Options<CloudpaymentsCancelApiV1PaymentsCloudpaymentsCancelPostData, ThrowOnError>): RequestResult<CloudpaymentsCancelApiV1PaymentsCloudpaymentsCancelPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<CloudpaymentsCancelApiV1PaymentsCloudpaymentsCancelPostResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/payments/cloudpayments/cancel',
    ...options
});

/**
 * Cloudpayments Fail
 *
 * Fail notification: payment declined. Log only, never grant access.
 */
export const cloudpaymentsFailApiV1PaymentsCloudpaymentsFailPost = <ThrowOnError extends boolean = true>(options?: Options<CloudpaymentsFailApiV1PaymentsCloudpaymentsFailPostData, ThrowOnError>): RequestResult<CloudpaymentsFailApiV1PaymentsCloudpaymentsFailPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<CloudpaymentsFailApiV1PaymentsCloudpaymentsFailPostResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/payments/cloudpayments/fail',
    ...options
});

/**
 * Google Rtdn
 *
 * Handle Google Pub/Sub push notifications for subscription lifecycle.
 */
export const googleRtdnApiV1PaymentsGoogleRtdnPost = <ThrowOnError extends boolean = true>(options?: Options<GoogleRtdnApiV1PaymentsGoogleRtdnPostData, ThrowOnError>): RequestResult<GoogleRtdnApiV1PaymentsGoogleRtdnPostResponses, GoogleRtdnApiV1PaymentsGoogleRtdnPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<GoogleRtdnApiV1PaymentsGoogleRtdnPostResponses, GoogleRtdnApiV1PaymentsGoogleRtdnPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/payments/google/rtdn',
    ...options
});

/**
 * Apple Server Notifications V2
 *
 * App Store Server Notifications V2 (JSON body with signedPayload).
 */
export const appleServerNotificationsV2ApiV1PaymentsAppleNotificationsPost = <ThrowOnError extends boolean = true>(options: Options<AppleServerNotificationsV2ApiV1PaymentsAppleNotificationsPostData, ThrowOnError>): RequestResult<AppleServerNotificationsV2ApiV1PaymentsAppleNotificationsPostResponses, AppleServerNotificationsV2ApiV1PaymentsAppleNotificationsPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AppleServerNotificationsV2ApiV1PaymentsAppleNotificationsPostResponses, AppleServerNotificationsV2ApiV1PaymentsAppleNotificationsPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/payments/apple/notifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rustore Server Notifications
 *
 * Receive RuStore server notifications; authenticity = successful AES-GCM decrypt.
 */
export const rustoreServerNotificationsApiV1PaymentsRustoreNotificationsPost = <ThrowOnError extends boolean = true>(options: Options<RustoreServerNotificationsApiV1PaymentsRustoreNotificationsPostData, ThrowOnError>): RequestResult<RustoreServerNotificationsApiV1PaymentsRustoreNotificationsPostResponses, RustoreServerNotificationsApiV1PaymentsRustoreNotificationsPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<RustoreServerNotificationsApiV1PaymentsRustoreNotificationsPostResponses, RustoreServerNotificationsApiV1PaymentsRustoreNotificationsPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/payments/rustore/notifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apple Verify Purchase
 *
 * Verify Apple IAP transaction (StoreKit 2). Same contract as ``/subscription/verify-purchase``.
 */
export const appleVerifyPurchaseApiV1PaymentsAppleVerifyPost = <ThrowOnError extends boolean = true>(options: Options<AppleVerifyPurchaseApiV1PaymentsAppleVerifyPostData, ThrowOnError>): RequestResult<AppleVerifyPurchaseApiV1PaymentsAppleVerifyPostResponses, AppleVerifyPurchaseApiV1PaymentsAppleVerifyPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AppleVerifyPurchaseApiV1PaymentsAppleVerifyPostResponses, AppleVerifyPurchaseApiV1PaymentsAppleVerifyPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zAppleVerifyPurchaseApiV1PaymentsAppleVerifyPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/payments/apple/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Subscription Status
 *
 * Get subscription status for current user.
 */
export const subscriptionStatusApiV1SubscriptionStatusGet = <ThrowOnError extends boolean = true>(options?: Options<SubscriptionStatusApiV1SubscriptionStatusGetData, ThrowOnError>): RequestResult<SubscriptionStatusApiV1SubscriptionStatusGetResponses, SubscriptionStatusApiV1SubscriptionStatusGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<SubscriptionStatusApiV1SubscriptionStatusGetResponses, SubscriptionStatusApiV1SubscriptionStatusGetErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSubscriptionStatusApiV1SubscriptionStatusGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/subscription/status',
    ...options
});

/**
 * Apple App Account Token
 *
 * Return stable UUID for StoreKit 2 appAccountToken (create once per user).
 */
export const appleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGet = <ThrowOnError extends boolean = true>(options?: Options<AppleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGetData, ThrowOnError>): RequestResult<AppleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<AppleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGetResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zAppleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGetResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/subscription/apple-app-account-token',
    ...options
});

/**
 * Subscription Cancel
 *
 * Cancel recurrent subscription.
 *
 * Sets cancelled=true, keeps active_until unchanged (user keeps access until expiration).
 * Idempotent - safe to call multiple times. RuStore: 409 (cancel only in RuStore app).
 */
export const subscriptionCancelApiV1SubscriptionCancelPost = <ThrowOnError extends boolean = true>(options?: Options<SubscriptionCancelApiV1SubscriptionCancelPostData, ThrowOnError>): RequestResult<SubscriptionCancelApiV1SubscriptionCancelPostResponses, SubscriptionCancelApiV1SubscriptionCancelPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<SubscriptionCancelApiV1SubscriptionCancelPostResponses, SubscriptionCancelApiV1SubscriptionCancelPostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSubscriptionCancelApiV1SubscriptionCancelPostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/subscription/cancel',
    ...options
});

/**
 * Verify Purchase
 *
 * Verify mobile store purchase and activate premium for current user.
 */
export const verifyPurchaseApiV1SubscriptionVerifyPurchasePost = <ThrowOnError extends boolean = true>(options: Options<VerifyPurchaseApiV1SubscriptionVerifyPurchasePostData, ThrowOnError>): RequestResult<VerifyPurchaseApiV1SubscriptionVerifyPurchasePostResponses, VerifyPurchaseApiV1SubscriptionVerifyPurchasePostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<VerifyPurchaseApiV1SubscriptionVerifyPurchasePostResponses, VerifyPurchaseApiV1SubscriptionVerifyPurchasePostErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zVerifyPurchaseApiV1SubscriptionVerifyPurchasePostResponse.parseAsync(data),
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/subscription/verify-purchase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Health Check
 *
 * Health check endpoint for API v1.
 */
export const healthCheckApiV1HealthGet = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckApiV1HealthGetData, ThrowOnError>): RequestResult<HealthCheckApiV1HealthGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<HealthCheckApiV1HealthGetResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/health',
    ...options
});

/**
 * Root
 *
 * Root endpoint for API v1.
 */
export const rootApiV1Get = <ThrowOnError extends boolean = true>(options?: Options<RootApiV1GetData, ThrowOnError>): RequestResult<RootApiV1GetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<RootApiV1GetResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/',
    ...options
});

/**
 * Google Rtdn
 *
 * Handle Google Pub/Sub push notifications for subscription lifecycle.
 */
export const googleRtdnV1PaymentsGoogleRtdnPost = <ThrowOnError extends boolean = true>(options?: Options<GoogleRtdnV1PaymentsGoogleRtdnPostData, ThrowOnError>): RequestResult<GoogleRtdnV1PaymentsGoogleRtdnPostResponses, GoogleRtdnV1PaymentsGoogleRtdnPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<GoogleRtdnV1PaymentsGoogleRtdnPostResponses, GoogleRtdnV1PaymentsGoogleRtdnPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/payments/google/rtdn',
    ...options
});

/**
 * Health Check
 *
 * Health check endpoint.
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckHealthGetData, ThrowOnError>): RequestResult<HealthCheckHealthGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health',
    ...options
});
